// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-03T22:58:02.563Z
// Property: Residences at Prairiefire Apartment Homes (ID: 6767906449167620)
// Collections: 48 amenities, 6 floorplans (live), 38 photos, 75 POIs, 5 reviews, 5 virtual tours, 6 office hours, 17 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162465",
  "multihub_property_id": "6767906449167620",
  "property_external_id": "2285777",
  "property_zillow_url": null,
  "property_apartments_url": "https://www.apartments.com/residences-at-prairiefire-overland-park-ks/wpbdqel/",
  "property_google_business_url": "https://www.google.com/maps/place/Residences+at+Prairiefire/@38.8814181,-94.6515217,891m/data=!3m2!1e3!4b1!4m6!3m5!1s0x87c0c1f1ce1662a3:0x37e29ea2b23f535f!8m2!3d38.8814181!4d-94.6515217!16s%2Fg%2F1ptyh16p5?entry=ttu&g_ep=EgoyMDI2MDkxNi4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": "2285777 p2252905",
  "property_status": null,
  "property_slug": "residences-at-prairiefire-apartment-homes",
  "property_name": "Residences at Prairiefire Apartment Homes",
  "property_website_url": "https://www.residencesatprairiefire.com/",
  "property_domain": "https://www.residencesatprairiefire.com/",
  "property_address": "5750 W 137th St",
  "property_full_address": "5750 W 137th St, Overland Park, KS 66223",
  "property_address_1": "5750 W 137th St",
  "property_address_2": null,
  "property_address_city": "Overland Park",
  "property_address_state": "KS",
  "property_address_zip_full": null,
  "property_address_zip": "66223",
  "property_address_country": "US",
  "property_address_county": "Johnson County",
  "property_neighborhood_address": "Prairiefire",
  "property_address_latitude": "38.8814435",
  "property_address_longitude": "-94.65152379999999",
  "property_email": "rentcafe.pf@pricekc.com",
  "property_phone": "(913) 933-8495",
  "property_call_tracking_phone": "913-933-8495",
  "property_company_name": "Price Brothers",
  "property_company_url": "https://www.pricebrotherskc.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "<p><strong>Polished Overland Park living meets Prairiefire energy.</strong> Spacious one-, two-, and three-bedroom apartment homes pair elevated finishes with resort-style spaces, all moments from dining, shopping, entertainment, and quick highway connections.</p>",
  "property_long_description": "<p>Welcome to Residences at Prairiefire, a community of one-, two-, and three-bedroom luxury apartments in the heart of the Prairiefire district in Overland Park, KS. Every home features stainless steel appliances, granite countertops, oversized closets, and soaring 9- to 12-foot ceilings, and select homes add a kitchen island, built-in wine rack, front-loading washer and dryer, or a golf course or pool view.</p><p>Life at Residences at Prairiefire extends well beyond your front door. Relax at the swimming pool with tanning ledges, gather around the poolside fire lounge with TV, or host a cookout at the outdoor kitchen cabana. A fitness center, clubhouse, cyber café, business center, car care center, and bike repair station round out the community amenities, and our pet-friendly community includes dog stations throughout the grounds.</p><p>Located at 5750 W 137th St near W 135th Street and Nall Avenue, Residences at Prairiefire offers quick access to US-69 and I-435, along with dining, shopping, and entertainment at the Museum at Prairiefire and AMC DINE-IN Prairiefire 17. Browse our <a href=\"/gallery\">photo gallery</a>, <a href=\"/neighborhood\">explore the neighborhood</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> today.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-2ece-756f-84a6-f6f64841270c.webp",
  "property_featured_image_media": {
    "alt_text": "Living room with a sofa, coffee table, and TV, overlooking a balcony with a view of the community pool.",
    "public_id": "01a0c4a9-2ece-756f-84a6-f6f64841270c",
    "storage_key": "property/6767906449167620/01a0c4a9-2ece-756f-84a6-f6f64841270c.webp",
    "width": 3072,
    "height": 2032
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "426",
  "property_year_built": "2015",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.71361502347418",
  "property_admin_fee": null,
  "property_application_fee": null,
  "property_fees_deposit_info": "Deposit: $200-300",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "25",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "We welcome dogs and cats up to 75 lbs. Maximum of 2 pets per unit.",
  "property_pet_policy_description": "The non-refundable fee is $300 for 1 pet, and $500 for 2 pets.",
  "property_petpolicy_info": "https://www.pricebrotherskc.com/petroyaltyclub/",
  "property_online_leasing_url": "https://residencesatprairiefire.securecafeapplicant.com/onlineleasing/content3/access/residences-at-prairiefire/floorplans",
  "property_resident_portal_url": "https://residencesatprairiefire.securecafe.com/residentservices/residences-at-prairiefire/userlogin.aspx",
  "property_apply_now_url": "https://residencesatprairiefire.securecafeapplicant.com/onlineleasing/content3/access/residences-at-prairiefire/login",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98c-dfb7-7521-aa0b-19e56b794904.webp",
  "property_primary_logo_media": {
    "alt_text": "Residences at Prairefire Apartment Homes logo",
    "public_id": "019fc98c-dfb7-7521-aa0b-19e56b794904",
    "storage_key": "property/6767906449167620/019fc98c-dfb7-7521-aa0b-19e56b794904.webp",
    "width": 606,
    "height": 185
  },
  "property_secondary_logo": null,
  "property_secondary_logo_media": null,
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc991-30c2-769b-aa19-ae24ec9b3989.webp",
  "property_mono_white_logo_media": {
    "alt_text": null,
    "public_id": "019fc991-30c2-769b-aa19-ae24ec9b3989",
    "storage_key": "property/6767906449167620/019fc991-30c2-769b-aa19-ae24ec9b3989.webp",
    "width": 606,
    "height": 185
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc991-1370-728b-b798-211556715c6d.webp",
  "property_mono_black_logo_media": {
    "alt_text": null,
    "public_id": "019fc991-1370-728b-b798-211556715c6d",
    "storage_key": "property/6767906449167620/019fc991-1370-728b-b798-211556715c6d.webp",
    "width": 606,
    "height": 185
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/01a0d9b7-62d2-753a-a137-bd690ff6733b.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_logo_media": null,
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff68a-de80-741a-9687-3e84c8c517e3.webp",
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162465/019ff682-589f-76db-bc7c-d7916fa7e182.webp",
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#414042",
  "property_secondary_color": "#DECD63",
  "property_font_color": null,
  "property_color_4": "#A4493D",
  "property_color_3": "#E1523D",
  "property_color_5": "#F7901E",
  "property_color_6": "#94A545",
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "845 - 1357",
  "property_sqft_min": "845",
  "property_sqft_max": "1357",
  "property_price_range": "1733 - 4565",
  "property_price_min": "1733",
  "property_price_max": "4565",
  "property_available_units": 14,
  "property_facebook_url": "https://www.facebook.com/ResidencesAtPrairiefire",
  "property_instagram_url": "https://www.instagram.com/residencesatprairiefire/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJo2IWzvHBwIcRX1M_sqKe4jc",
  "property_youtube_url": "https://www.youtube.com/user/Pricebrothersmgt",
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Residences at Prairiefire Apartment Homes",
  "property_home_romance_title": "Embrace Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, resort-style downtime.</strong> Controlled building access, package receiving, garage options, bike repair, and a car care center keep routines simple, while a saltwater pool with tanning ledges, poolside fire lounge with TV, fitness center, cyber café, business center, and clubhouse add room to recharge. Inside, granite countertops, stainless steel appliances, soaring ceilings, oversized closets, and in-home laundry set a polished tone, with select homes offering wine chillers, kitchen islands, shower benches, and golf course or pool views.</p>",
  "property_home_floorplans_blurb": "<p>Residences at Prairiefire has 426 apartment homes that average more than 1,000 square feet. With six floor plans, accessible apartments, and elevators in every four-story building, there’s a layout for the way you live. <a href=\"/floor-plans\">Compare floor plans</a> to find yours.</p>",
  "property_home_gallery_blurb": "<p>Take a closer look at our apartment interiors, community amenities, and the surrounding Prairiefire retail and entertainment district. Browse the <a href=\"/gallery\">photo gallery</a> for a preview of your next home.</p>",
  "property_home_neighborhood_blurb": "<p>Residences at Prairiefire places you close to the restaurants, shops, and entertainment of the Prairiefire district, including the Museum at Prairiefire and AMC DINE-IN Prairiefire 17. Nearby employers include HCA Midwest Health, T-Mobile, and The University of Kansas Health System, and the Nicklaus Golf Club at LionsGate is a short drive away. Visit our <a href=\"/neighborhood\">Neighborhood page</a> to see more of what is nearby.</p>",
  "property_home_reviews_blurb": "<p><strong>Prairiefire living, backed by real resident feedback.</strong> Reviews highlight attentive office support, responsive maintenance, clean move-in-ready apartments, and communication that makes the process feel easy from the start. Residents also call out well-kept spaces, useful amenities, and a convenient Overland Park setting close to dining, activities, and daily essentials. Read more to see why one resident says it offers “so much more than just an apartment.”</p>",
  "property_neighborhood_blurb": "<p>Residences at Prairiefire is located at 5750 W 137th St in Overland Park, KS, inside the Prairiefire district near 135th Street and Nall Avenue. The Museum at Prairiefire and AMC DINE-IN Prairiefire 17 are steps away.</p><p>Looking for a place to eat near Residences at Prairiefire? Our team recommends Urban Egg for brunch, Bamboo Penny’s, and Whole Harvest Kitchen, all in the Prairiefire shopping area. Rock &amp; Brews, Barley’s Kitchen + Tap, Talk of the Town Grill &amp; Bar, and Joe’s Kansas City Bar-B-Que are also close by, and Winstead’s and Andy’s Frozen Custard are local favorites. For errands, McKeever’s Price Chopper, HomeGoods, and Costco are all nearby.</p><p>US-69 and I-435 connect Residences at Prairiefire to employers across the Kansas City area, including HCA Midwest Health, T-Mobile, The University of Kansas Health System Corbin Park, Menorah Medical Center, and Saint Luke’s South Hospital. The University of Kansas Edwards Campus and Blue Valley School District schools are also nearby.</p><p>For time outdoors, visit Prairie Oak Nature Center, the Blue Valley Recreation Sports Complex, or Nicklaus Golf Club at LionsGate.</p><p>Explore our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a>, or <a href=\"/contact-us\">contact us</a> to schedule a tour.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Residences at Prairiefire offers a swimming pool with tanning ledges, a poolside fire lounge with TV, and an outdoor kitchen cabana for cookouts. Residents also have a fitness center, a clubhouse, a business center, and a cyber café.</p><p>Everyday conveniences include a car care center, a bike repair and cleaning station, package receiving, controlled building access, detached garages, elevators in every four-story building, flexible rent payment options, and on-site management and maintenance. Planned resident events take place throughout the year.</p><p>Inside each one-, two-, or three-bedroom apartment, enjoy stainless steel appliances, granite countertops, a kitchen pantry, ceiling fans, oversized closets, and 9 to 12-foot ceilings. Select homes include a front-loading washer and dryer, kitchen island, wine chiller, built-in wine rack, generous shower with bench, linen closet, hardwood flooring, renovated design, or a golf course or pool view. Accessible apartments are available.</p><p>Ready to see these amenities in person? <a href=\"/schedule-a-tour\">Schedule a tour</a> of Residences at Prairiefire today.</p>",
  "property_applynow_blurb": "<p><strong>Start your application at Residences at Prairiefire.</strong> Spacious one-, two-, and three-bedroom apartment homes pair polished finishes like granite countertops, stainless steel appliances, hardwood-style flooring, and in-home laundry with the energy of Prairiefire right outside. Apply online today and move one step closer to Overland Park living with color, culture, and convenience.</p>",
  "property_contactus_blurb": "<p>Have questions about Residences at Prairiefire? Our team can help with available <a href=\"/floor-plans\">floor plans</a>, pricing, community and apartment <a href=\"/amenities\">amenities</a>, our <a href=\"/pet-policy\">pet policy</a>, or <a href=\"/schedule-a-tour\">scheduling a tour</a>.</p><p>Call us at <a href=\"tel:+19139338495\">(913) 933-8495</a>, visit the leasing office at 5750 W 137th St, Overland Park, KS 66223, or complete the contact form above. Our office is open Monday through Friday from 9:30 AM to 5:30 PM and Saturday from 10 AM to 5 PM.</p>",
  "property_faqs_blurb": "<p>Find answers to common questions about applications, deposits, lease terms, tours, pets, utilities, renters insurance, rent payments, parking, packages, and maintenance requests at Residences at Prairiefire. You can also review our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more details.</p><p>If you do not see the answer you need, <a href=\"/contact-us\">contact us</a>. Our team is happy to help.</p>",
  "property_floorplans_blurb": "<p>Residences at Prairiefire offers six floor plans ranging from 845 to 1,497 square feet, each named for a celebrated museum. Choose from the A1 Getty (845 sq. ft.) and A2 Guggenheim (954 sq. ft.) one-bedroom, one-bath apartments; the B1 Met (1,168 sq. ft.), B2 Pompidou (1,175 sq. ft.), and B3 MoMA (1,357 sq. ft.) two-bedroom, two-bath apartments; or the C1 Prado, a 1,497-square-foot three-bedroom apartment.</p><p>Every floor plan includes stainless steel appliances, granite countertops, oversized closets, and 9 to 12-foot ceilings. Depending on the home you choose, you may also find hardwood flooring, a kitchen island, a wine chiller, a generous shower with a bench, a linen closet, or a golf course or pool view. Accessible apartments are available, and additional storage can be added.</p><p>Each floor plan includes a 360° tour so you can explore the layout online, along with current pricing and availability. Review the full list of <a href=\"/amenities\">community and apartment amenities</a>, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see Residences at Prairiefire in person.</p>",
  "property_gallery_blurb": "<p>Browse the photo gallery for a closer look at Residences at Prairiefire in Overland Park, KS. Filter by interior, amenities, exterior, or Prairiefire retail and entertainment to see apartment kitchens and living spaces, the swimming pool and fire lounge, the outdoor kitchen cabana, and the shops and attractions nearby.</p><p>Look for details like stainless steel appliances, granite countertops, oversized closets, and select homes with golf course views. After browsing, compare our <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Residences at Prairiefire in person.</p>",
  "property_interactivemap_blurb": "<p>Use our interactive property map to explore available apartments at Residences at Prairiefire by location within the community. Filter by floor level, golf course or pool view, hardwood flooring, ceiling fans, and accessible apartments, then select a home to view pricing and availability.</p><p>Review our <a href=\"/floor-plans\">floor plans</a> and <a href=\"/amenities\">amenities</a> for more details, or <a href=\"/contact-us\">contact us</a> to schedule a tour.</p>",
  "property_pets_blurb": "<p>Residences at Prairiefire is a pet-friendly community with dog stations on site. We welcome dogs and cats, with a maximum of two pets per apartment.</p><ul><li><strong>Monthly pet rent:</strong> $25 per pet</li><li><strong>Non-refundable pet fee:</strong> $300 for one pet or $500 for two pets</li></ul><p>Breed Restrictions: Restricted breeds include Pit Bull, American Staffordshire Terrier, Rottweiler, German Shepherd, Malamute, Doberman Pinscher, Chow, Great Dane, Saint Bernard, Akita, Wolf Hybrid, and mixes containing any of these breeds. Management may restrict additional breeds. Exotic, feral, wild, or inherently dangerous animals are not permitted.</p>",
  "property_referafriend_blurb": "<p><strong>Share the Prairiefire experience.</strong> From polished apartment finishes to resort-style amenities and the energy of Prairiefire right outside, there’s plenty to love here. Invite a friend to explore the community and find their next home at Residences at Prairiefire.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access made easy.</strong><br>From your home at Residences at Prairiefire, log in to pay rent, submit maintenance requests, and manage your account—simple everyday convenience that keeps pace with polished Overland Park living.</p>",
  "property_reviews_blurb": "<p>Read Residences at Prairiefire reviews from the people who know the community best. See what residents say about life in our Overland Park apartments, then share your own experience by rating parking, amenities, maintenance, staff, value, location, and noise.</p><p>Thinking about moving in? Browse our <a href=\"/floor-plans\">floor plans</a> or <a href=\"/schedule-a-tour\">schedule a tour</a>.</p>",
  "property_created_at": "1785792834909",
  "property_scheduletour_blurb": "<p>Tour Residences at Prairiefire in person to see available apartments, the pool and fire lounge, and the Prairiefire district right outside the community. Our leasing team will walk you through floor plans, pricing, and features during your visit. Prefer to start online? Every <a href=\"/floor-plans\">floor plan</a> has a 360° tour.</p><p>Tours are available during office hours, Monday through Friday from 9:30 a.m. to 5:30 p.m. and Saturday from 10 a.m. to 5 p.m. Everyone 18 and older will need a valid photo ID to tour.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—your inquiry has been received.</strong><br>Our leasing team will be in touch soon. In the meantime, picture polished Overland Park living with spacious apartment homes, elevated finishes, resort-style amenities, and the color, culture, and convenience of Prairiefire right outside your door.</p>",
  "property_virtualtours_blurb": "<p><strong>Walk the layout before you visit.</strong> The virtual tours at Residences at Prairiefire Apartment Homes let you move room by room through the floor plans available to preview: A1 - GETTY and A2 - GUGGENHEIM one-bedroom apartments, plus B1 - MET, B2 - POMPIDOU, and B3 - MOMA two-bedroom apartments.</p><p>Look closely at the details that shape everyday living—open living areas, polished kitchens with granite countertops and stainless steel appliances, oversized closets, in-home laundry connections or appliances, and select touches like kitchen islands, elevated views, and private outdoor space. As you click through each tour, compare the flow, storage, natural light, and bedroom placement from wherever you are, then explore current <a href=\"/floor-plans\">floor plan availability</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Overland Park apartment in person.</p>",
  "property_copyright": "2026 All Rights Reserved. Residences at Prairiefire Apartment Homes",
  "property_seo_title_home": "Luxury Apartments in Overland Park, KS",
  "property_seo_description_home": "Residences at Prairiefire offers 1, 2 & 3-bedroom luxury apartments in Overland Park, KS, near the Prairiefire district, with resort-style amenities.",
  "property_seo_title_floorplans": "1, 2 & 3-Bedroom Apartments in Overland Park, KS",
  "property_seo_description_floorplans": "Compare six 1, 2 & 3-bedroom floor plans from 845 to 1,497 sq. ft. at Residences at Prairiefire in Overland Park, KS. View 360° tours and availability.",
  "property_seo_title_amenities": "Apartment Amenities in Overland Park, KS",
  "property_seo_description_amenities": "See the amenities at Residences at Prairiefire, from a pool with tanning ledges and fire lounge to a fitness center, cabana, and pet-friendly policy.",
  "property_seo_title_gallery": "Residences at Prairiefire | Photo Gallery",
  "property_seo_description_gallery": "Browse photos of Residences at Prairiefire in Overland Park, KS, including apartment interiors, the pool and fire lounge, and nearby Prairiefire shops.",
  "property_seo_title_virtualtours": "Virtual Tours | Residences at Prairiefire Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step inside Residences at Prairiefire in Overland Park, KS. Experience our one to three-bedroom layouts with a virtual tour. Your new home awaits!",
  "property_seo_title_interactivemap": "Interactive Property Map | Residences at Prairiefire",
  "property_seo_description_interactivemap": "Use the interactive property map at Residences at Prairiefire to find available apartments by floor, view, and features in Overland Park, KS.",
  "property_seo_title_neighborhood": "Apartments Near Prairiefire in Overland Park, KS",
  "property_seo_description_neighborhood": "Residences at Prairiefire sits near W 135th St and Nall Ave in Overland Park, KS, close to the Museum at Prairiefire, AMC DINE-IN, I-435, and US-69.",
  "property_seo_title_contact": "Contact Residences at Prairiefire | Overland Park, KS",
  "property_seo_description_contact": "Contact Residences at Prairiefire in Overland Park, KS to ask about floor plans, pricing, availability, pet policies, or scheduling a tour.",
  "property_seo_title_faqs": "FAQs | Residences at Prairiefire",
  "property_seo_description_faqs": "Find answers about applications, pets, utilities, renters insurance, parking, and maintenance at Residences at Prairiefire in Overland Park, KS.",
  "property_seo_title_reviews": "Reviews | Residences at Prairiefire",
  "property_seo_description_reviews": "Read resident reviews of Residences at Prairiefire in Overland Park, KS, and share your own experience with parking, amenities, staff, and more.",
  "property_seo_title_applynow": "Apply Now | Apartments in Overland Park, KS",
  "property_seo_description_applynow": "Discover your perfect home at Residences at Prairiefire, Overland Park, KS! Enjoy a saltwater pool, fitness center, and pet-friendly options. Apply now!",
  "property_seo_title_residentaccess": "Resident Access | Residences at Prairiefire Apartment Homes",
  "property_seo_description_residentaccess": "Welcome home to Residences at Prairiefire! Log in to access your resident portal for convenient rent payments, maintenance requests, and community updates.",
  "property_seo_title_referafriend": "Refer A Friend | Residences at Prairiefire Apartment Homes",
  "property_seo_description_referafriend": "Refer a friend to Residences at Prairiefire in Overland Park! Share the joy of community and enjoy exclusive rewards when they join our vibrant neighborhood.",
  "property_seo_title_scheduletour": "Schedule a Tour | Residences at Prairiefire",
  "property_seo_description_scheduletour": "Schedule a tour of Residences at Prairiefire in Overland Park, KS and see our 1, 2 & 3-bedroom apartments, amenities, and community in person.",
  "property_seo_title_privacy": "Privacy Policy | Residences at Prairiefire Apartment Homes",
  "property_seo_description_privacy": "Experience serenity at Residences at Prairiefire in Overland Park, KS. Explore our privacy policy for peace of mind in apartment living.",
  "property_seo_title_accessibility": "Website Accessibility | Residences at Prairiefire Apartment Homes",
  "property_seo_description_accessibility": "At Residences at Prairiefire in Overland Park, we champion digital inclusion with our strong commitment to accessibility for all. Your comfort matters!",
  "property_seo_title_sitemap": "Sitemap | Residences at Prairiefire Apartment Homes",
  "property_seo_description_sitemap": "Navigate the Residences at Prairiefire in Overland Park, KS. Find your ideal home, amenities, and community highlights in our comprehensive sitemap!",
  "property_seo_title_thankyou": "Thank You | Residences at Prairiefire Apartment Homes",
  "property_seo_description_thankyou": "Thanks for reaching out! We're excited to connect you with your future home at Residences at Prairiefire in Overland Park!",
  "property_seo_title_pets": "Pet Policy | Apartments in Overland Park, KS",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793655066708",
  "amenities": [
    {
      "id": "ec_5f76a277865a922751b1dd17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126308789",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-4ad7-7444-a946-8653b41d9d38.webp",
      "amenity_image_media": {
        "alt_text": "Business center with computers and printer, and cafe seating area.",
        "public_id": "01a0c4a9-4ad7-7444-a946-8653b41d9d38",
        "storage_key": "property/6767906449167620/01a0c4a9-4ad7-7444-a946-8653b41d9d38.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Business center at Residences at Prairiefire with computer stations, modern décor, and vibrant orange seating. at Residences at Prairiefire Apartment Homes, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53b7ee22096c80f1b4a02499",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112612",
      "title": "Elevators*",
      "amount": "false",
      "description": "*in 4-Story Buildings",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_159b3bebfedfe905b23da0dc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112607",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-4ac8-702a-8f41-823709186f6f.webp",
      "amenity_image_media": {
        "alt_text": "Modern lounge with fireplace and seating areas.",
        "public_id": "01a0c4a9-4ac8-702a-8f41-823709186f6f",
        "storage_key": "property/6767906449167620/01a0c4a9-4ac8-702a-8f41-823709186f6f.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Elegant clubhouse lounge at Residences at Prairiefire with modern fireplace, flat-screen TVs, and contemporary seating. at Residences at Prairiefire Apartment Homes, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e198533027fc60023355f39a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126308785",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-841a-7528-b1e4-72cea7911d90.webp",
      "amenity_image_media": {
        "alt_text": "State-of-the-art fitness center with cardio machines, weight benches, and free weights.",
        "public_id": "019fc990-841a-7528-b1e4-72cea7911d90",
        "storage_key": "property/6767906449167620/019fc990-841a-7528-b1e4-72cea7911d90.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Spacious fitness center at Residences at Prairiefire with cardio machines, weight equipment, and large windows for natural light. at Residences at Prairiefire Apartment Homes, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4d8ac35380a52207262c823e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112592",
      "title": "Cyber Café",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_62bbe4b13b9dc1bc84839eae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112608",
      "title": "Shimmering Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98f-b531-7782-8a83-7e4b1dee3990.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a multi-tiered fountain.",
        "public_id": "019fc98f-b531-7782-8a83-7e4b1dee3990",
        "storage_key": "property/6767906449167620/019fc98f-b531-7782-8a83-7e4b1dee3990.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Sparkling pool with central fountain and clubhouse backdrop  at Residences at Prairiefire Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eff04f8e8ae9996b211903ae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112596",
      "title": "Poolside Fire Lounge with TV",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98f-b702-76cf-8100-b830a07a350e.webp",
      "amenity_image_media": {
        "alt_text": "Outdoor lounge seating area with pool and apartment buildings in the background.",
        "public_id": "019fc98f-b702-76cf-8100-b830a07a350e",
        "storage_key": "property/6767906449167620/019fc98f-b702-76cf-8100-b830a07a350e.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Outdoor lounge with orange cushioned seating under a pergola near the pool  at Residences at Prairiefire Apartment Homes, Overland Park, KS, 66223,Outdoor lounge with stone fireplace and vibrant orange seating  at Residences at Prairiefire Apartment Homes, Overland Park, 66223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_83f92a64749b4455f54f132e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112594",
      "title": "Tanning Ledges",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a1-f1c3-70bf-806d-d52f48d2c741.webp",
      "amenity_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019ff6a1-f1c3-70bf-806d-d52f48d2c741",
        "storage_key": "property/6767906449167620/019ff6a1-f1c3-70bf-806d-d52f48d2c741.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Large swimming pool with orange umbrellas and sun loungers  at Residences at Prairiefire Apartment Homes, Overland Park, KS,Resort-style pool area at Residences at Prairiefire in Overland Park, KS with lounge chairs, umbrellas, and landscaped surroundings. at Residences at Prairiefire Apartment Homes, Overland Park, KS, 66",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2ba726dbb570ee079ea7b431",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112597",
      "title": "Outdoor Kitchen Cabana",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74ecc869f107e3d0453100bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112602",
      "title": "Car Care Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98f-ddc6-769e-8adb-9b39e757009c.webp",
      "amenity_image_media": {
        "alt_text": "Covered car wash station with hoses and brushes.",
        "public_id": "019fc98f-ddc6-769e-8adb-9b39e757009c",
        "storage_key": "property/6767906449167620/019fc98f-ddc6-769e-8adb-9b39e757009c.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Car care station at Residences at Prairiefire in Overland Park, KS featuring a covered awning, car vacuum, and sprayer arm for residents. at Residences at Prairiefire Apartment Homes, Kansas, 66223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a4b538fca7285b11a1fc163b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112599",
      "title": "Bike Repair & Cleaning Station",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_04f6ef702031c30e88ed064a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126308784",
      "title": "Pet-Friendly with Dog Stations",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bf54889acbf8bc35d128f9b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126373609",
      "title": "Detached Garages",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b2cb432b765587ae170bfc73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112600",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_468a81a4533f847ba42c749d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126308777",
      "title": "Controlled Building Access",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7b04dcb8f90531d60df3b712",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126308773",
      "title": "On-Site Management & Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ed0f700089b95adb8889f8de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112604",
      "title": "Flexible Rent Payment Options",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_854a607b4bd1014a85f6d480",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126308768",
      "title": "Convenient Location",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_262c23ee79369ab13f392426",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464979",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3efcaa8db148699d74fee1ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112648",
      "title": "Hardwood Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-3024-70e4-ba84-d967d965f4df.webp",
      "amenity_image_media": {
        "alt_text": "Modern living room with a sectional sofa, colorful accents, and a kitchen island.",
        "public_id": "019fc990-3024-70e4-ba84-d967d965f4df",
        "storage_key": "property/6767906449167620/019fc990-3024-70e4-ba84-d967d965f4df.webp",
        "width": 3072,
        "height": 2052
      },
      "amenity_image_alt_text": "Stylish living room at Residences at Prairiefire featuring a bold magenta accent wall, sectional sofa, and breakfast bar with colorful seating. at Residences at Prairiefire Apartment Homes, Overland P",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a688583f91c035116680a4a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112615",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-0c2a-741a-99ae-7453156344d2.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019fc990-0c2a-741a-99ae-7453156344d2",
        "storage_key": "property/6767906449167620/019fc990-0c2a-741a-99ae-7453156344d2.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Elegant kitchen with granite countertops, stainless steel appliances, and wine storage  at Residences at Prairiefire Apartment Homes, Overland Park",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7e010cbf3deb5a6e44a81d00",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112628",
      "title": "Front-Loading Washer & Dryer*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fda715a5e9c3ec5833daea4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112643",
      "title": "Wine Chiller*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-0c2a-741a-99ae-7453156344d2.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019fc990-0c2a-741a-99ae-7453156344d2",
        "storage_key": "property/6767906449167620/019fc990-0c2a-741a-99ae-7453156344d2.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Elegant kitchen with granite countertops, stainless steel appliances, and wine storage  at Residences at Prairiefire Apartment Homes, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e76c7f8e28c0a4c707e5356f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112647",
      "title": "Kitchen Pantry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-1e3a-74ef-94f7-692a27ae7845.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fc990-1e3a-74ef-94f7-692a27ae7845",
        "storage_key": "property/6767906449167620/019fc990-1e3a-74ef-94f7-692a27ae7845.webp",
        "width": 3072,
        "height": 2050
      },
      "amenity_image_alt_text": "Gourmet kitchen with stainless steel appliances, granite countertops, and dining area  at Residences at Prairiefire Apartment Homes, Overland Park, 66223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0742e161a604644ba2abb3e8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126373615",
      "title": "Generous Shower with Bench*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a94c8f821a7dbfd477e294a8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126373617",
      "title": "Linen Closet*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_340cba6332c5db355e280fad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112616",
      "title": "Golf Course View*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_ea0571bd28f67249b1e77fd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464963",
      "title": "Golf Course View - Upgraded*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_626aaeb9fdcef8106a283e94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464965",
      "title": "Golf Course View - Premium",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b6ac009c48aacf80ae2b1c94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126373621",
      "title": "Soaring 9–12 Foot Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-5ec5-7768-ad41-e2cdcce05c31.webp",
      "amenity_image_media": {
        "alt_text": "Living room with sofa, coffee table, and view to bedroom and balcony.",
        "public_id": "019fc990-5ec5-7768-ad41-e2cdcce05c31",
        "storage_key": "property/6767906449167620/019fc990-5ec5-7768-ad41-e2cdcce05c31.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Stylish living room with balcony access and modern décor  at Residences at Prairiefire Apartment Homes, Overland Park, KS, 66223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0dc5f1c4494eb3117f0464f8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112641",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-0c2a-741a-99ae-7453156344d2.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, granite countertops, and dark wood cabinets.",
        "public_id": "019fc990-0c2a-741a-99ae-7453156344d2",
        "storage_key": "property/6767906449167620/019fc990-0c2a-741a-99ae-7453156344d2.webp",
        "width": 3072,
        "height": 2051
      },
      "amenity_image_alt_text": "Elegant kitchen with granite countertops, stainless steel appliances, and wine storage  at Residences at Prairiefire Apartment Homes, Overland Park, KS",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b1396bb57226bb3b169d34d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112642",
      "title": "Kitchen Island*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-1e3a-74ef-94f7-692a27ae7845.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fc990-1e3a-74ef-94f7-692a27ae7845",
        "storage_key": "property/6767906449167620/019fc990-1e3a-74ef-94f7-692a27ae7845.webp",
        "width": 3072,
        "height": 2050
      },
      "amenity_image_alt_text": "Gourmet kitchen with stainless steel appliances, granite countertops, and dining area  at Residences at Prairiefire Apartment Homes, Kansas, 66223",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c314410bddddee6f7bd679b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112644",
      "title": "Built-in Wine Rack*",
      "amount": "false",
      "description": "*in Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-1e3a-74ef-94f7-692a27ae7845.webp",
      "amenity_image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "019fc990-1e3a-74ef-94f7-692a27ae7845",
        "storage_key": "property/6767906449167620/019fc990-1e3a-74ef-94f7-692a27ae7845.webp",
        "width": 3072,
        "height": 2050
      },
      "amenity_image_alt_text": "Gourmet kitchen with stainless steel appliances, granite countertops, and dining area  at Residences at Prairiefire Apartment Homes, Overland Park, Kansas",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_59b18b1b5b704a846324c64f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112649",
      "title": "Oversized Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_297564a82fa1fd8bd878386c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126112652",
      "title": "Additional Storage Available",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2f0fbce98ab806b25f634894",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464698",
      "title": "Pool View*",
      "amount": "false",
      "description": "*with Select Homes",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_66de9b42a65e682f90459b79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464970",
      "title": "Pool View - Upgraded*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_12f8139550e4d3113959ce0b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464971",
      "title": "First Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e34487b3402fe02c448c4293",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464972",
      "title": "Second Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_377d980b8b65a4e81623e09c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464973",
      "title": "Third Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f362a538acd658ce7a60afa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464975",
      "title": "Fourth Floor",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7530d8b1ce43ec3910ec3288",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464976",
      "title": "Renovated Design*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93f255c38db2266852a1cdbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464977",
      "title": "Ceiling Fan in Primary Bedroom*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f26e201e2703902f00d03660",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464978",
      "title": "Ceiling Fan in Guest Bedroom*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d20f124634c84e7916e32993",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464980",
      "title": "Accessible Apartment",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7f7f28cbdea26724a2aefb6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464987",
      "title": "Oversized One Bedroom*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_cec0e433707cf2c85c66691d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126464992",
      "title": "Oversized Two Bedroom*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_659dfd650934c7833dcb9503",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "external_id": "126465001",
      "title": "Flattop Stove*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_5de399c58a61e517bef33cce",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-2ece-756f-84a6-f6f64841270c.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and TV, overlooking a balcony with a view of the community pool.",
        "public_id": "01a0c4a9-2ece-756f-84a6-f6f64841270c",
        "storage_key": "property/6767906449167620/01a0c4a9-2ece-756f-84a6-f6f64841270c.webp",
        "width": 3072,
        "height": 2032
      },
      "title": "Apartment",
      "description": "Stylish living room featuring a comfortable sofa, a sleek coffee table, and a modern entertainment center with a TV. Step out onto the balcony to enjoy the view of the community pool and surrounding landscape.",
      "link": "false",
      "alt_text": "Living room with a sofa, coffee table, and TV, overlooking a balcony with a view of the community pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 24(1).jpg"
    },
    {
      "id": "ec_7d3a570abc81eab045952469",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-74c3-7567-b36d-2fb1fd371bb5.webp",
      "image_media": {
        "alt_text": "Stylish living room with white sectional sofa, glass coffee table, and large window overlooking a balcony.",
        "public_id": "01a0c4a9-74c3-7567-b36d-2fb1fd371bb5",
        "storage_key": "property/6767906449167620/01a0c4a9-74c3-7567-b36d-2fb1fd371bb5.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious and modern living area, featuring plush seating and a balcony with scenic views.",
      "link": "false",
      "alt_text": "Stylish living room with white sectional sofa, glass coffee table, and large window overlooking a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 17.jpg"
    },
    {
      "id": "ec_3359180c3b045b5a3cd44bea",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-71a8-70a9-b1f4-fa410c277e80.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
        "public_id": "01a0c4a9-71a8-70a9-b1f4-fa410c277e80",
        "storage_key": "property/6767906449167620/01a0c4a9-71a8-70a9-b1f4-fa410c277e80.webp",
        "width": 3072,
        "height": 2064
      },
      "title": "Apartment",
      "description": "Stylish kitchen featuring a granite island, stainless steel appliances, and ample cabinet space for a sophisticated living experience.",
      "link": "false",
      "alt_text": "Modern kitchen with stainless steel appliances and granite countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 16.jpg"
    },
    {
      "id": "ec_ecf5423d7062a21b36270ffa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-71dc-71ed-84b6-a9190730cf96.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, dresser, and view of pool and buildings",
        "public_id": "01a0c4a9-71dc-71ed-84b6-a9190730cf96",
        "storage_key": "property/6767906449167620/01a0c4a9-71dc-71ed-84b6-a9190730cf96.webp",
        "width": 3072,
        "height": 2006
      },
      "title": "Apartment",
      "description": "Cozy bedroom with a queen-size bed, plush carpet, and a window overlooking the community pool and surrounding buildings.",
      "link": "false",
      "alt_text": "Bedroom with a queen-size bed, dresser, and view of pool and buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 31.jpg"
    },
    {
      "id": "ec_dbfa3b1e3cfbfedabdf6c150",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-7621-728b-ab95-d66326b5a6ef.webp",
      "image_media": {
        "alt_text": "Modern apartment kitchen with granite countertops, dark wood cabinets, stainless steel appliances, and island with bar stools.",
        "public_id": "01a0c4a9-7621-728b-ab95-d66326b5a6ef",
        "storage_key": "property/6767906449167620/01a0c4a9-7621-728b-ab95-d66326b5a6ef.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring a large island with seating, sleek granite countertops, stainless steel appliances, and ample cabinet space.",
      "link": "false",
      "alt_text": "Modern apartment kitchen with granite countertops, dark wood cabinets, stainless steel appliances, and island with bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 22.jpg"
    },
    {
      "id": "ec_1592b8acbfd94ae6f28b0244",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-6e63-7278-8490-0dadd0967397.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a queen-size bed and navy blue accent wall.",
        "public_id": "01a0c4a9-6e63-7278-8490-0dadd0967397",
        "storage_key": "property/6767906449167620/01a0c4a9-6e63-7278-8490-0dadd0967397.webp",
        "width": 3072,
        "height": 2013
      },
      "title": "Apartment",
      "description": "Spacious primary bedroom featuring a comfortable queen-size bed, a stylish navy blue accent wall, and large windows with sheer curtains.",
      "link": "false",
      "alt_text": "Primary bedroom with a queen-size bed and navy blue accent wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 29.jpg"
    },
    {
      "id": "ec_a34d611579d6ef83f7fc8ec8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-8d8e-76b9-80f2-8096da71be41.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a granite countertop vanity, white sink, and a bathtub with a shower curtain.",
        "public_id": "01a0c4a9-8d8e-76b9-80f2-8096da71be41",
        "storage_key": "property/6767906449167620/01a0c4a9-8d8e-76b9-80f2-8096da71be41.webp",
        "width": 3072,
        "height": 2064
      },
      "title": "Apartment",
      "description": "Elegant bathroom featuring a spacious vanity with a granite countertop, a clean white sink, and a bathtub with a decorative shower curtain. Experience comfort and style in every detail.",
      "link": "false",
      "alt_text": "Modern bathroom with a granite countertop vanity, white sink, and a bathtub with a shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 14.jpg"
    },
    {
      "id": "ec_5677f1ded889072adc52eddc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-893a-771a-b1c0-4f65969d72c7.webp",
      "image_media": {
        "alt_text": "Washer and dryer in a laundry room.",
        "public_id": "01a0c4a9-893a-771a-b1c0-4f65969d72c7",
        "storage_key": "property/6767906449167620/01a0c4a9-893a-771a-b1c0-4f65969d72c7.webp",
        "width": 1559,
        "height": 1016
      },
      "title": "Apartment",
      "description": "Convenient in-unit washer and dryer for your laundry needs.",
      "link": "false",
      "alt_text": "Washer and dryer in a laundry room.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/13412299.jpg"
    },
    {
      "id": "ec_47f5fca70780af2aa71b6f0a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-ae31-745e-ab66-a5430cff77ad.webp",
      "image_media": {
        "alt_text": "Bedroom with a king-size bed, two nightstands with lamps, and a dresser.",
        "public_id": "01a0c4a9-ae31-745e-ab66-a5430cff77ad",
        "storage_key": "property/6767906449167620/01a0c4a9-ae31-745e-ab66-a5430cff77ad.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious bedroom, featuring a plush king-size bed, ample storage, and a bright, airy atmosphere.",
      "link": "false",
      "alt_text": "Bedroom with a king-size bed, two nightstands with lamps, and a dresser.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 19.jpg"
    },
    {
      "id": "ec_07699cbead723439c9494343",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-9b3b-7639-b442-121901866da9.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop, vanity, toilet, and bathtub with shower curtain.",
        "public_id": "01a0c4a9-9b3b-7639-b442-121901866da9",
        "storage_key": "property/6767906449167620/01a0c4a9-9b3b-7639-b442-121901866da9.webp",
        "width": 3072,
        "height": 1974
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed apartment bathroom, featuring a granite vanity, modern fixtures, and a relaxing bathtub.",
      "link": "false",
      "alt_text": "Modern bathroom with granite countertop, vanity, toilet, and bathtub with shower curtain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 26.jpg"
    },
    {
      "id": "ec_2835a6f5e7683c15ef9fbba9",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-953f-7225-a615-dcb2c4eccf21.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with stone accents and balconies.",
        "public_id": "01a0c4a9-953f-7225-a615-dcb2c4eccf21",
        "storage_key": "property/6767906449167620/01a0c4a9-953f-7225-a615-dcb2c4eccf21.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover modern living at this apartment complex, featuring a stunning exterior with stone accents and private balconies.",
      "link": "false",
      "alt_text": "Exterior of a modern apartment building with stone accents and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/kcspaces-Prairie-Fire-28.jpg"
    },
    {
      "id": "ec_7c288c92787110ef49d4f57c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-a6ce-76f6-ab53-bcae2a5f8335.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment buildings, community pool, and surrounding golf course.",
        "public_id": "01a0c4a9-a6ce-76f6-ab53-bcae2a5f8335",
        "storage_key": "property/6767906449167620/01a0c4a9-a6ce-76f6-ab53-bcae2a5f8335.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing modern apartment buildings, a vibrant community pool area with lounge chairs, and the picturesque backdrop of a golf course.",
      "link": "false",
      "alt_text": "Aerial view of apartment buildings, community pool, and surrounding golf course.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 10.jpg"
    },
    {
      "id": "ec_294c5c50f3caf2a0c860dd2d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-a5cc-756f-93ee-c1c2e4d3ca50.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building with stone accents and balconies.",
        "public_id": "01a0c4a9-a5cc-756f-93ee-c1c2e4d3ca50",
        "storage_key": "property/6767906449167620/01a0c4a9-a5cc-756f-93ee-c1c2e4d3ca50.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Discover our beautiful apartment community, featuring modern exteriors and spacious balconies.",
      "link": "false",
      "alt_text": "Exterior view of apartment building with stone accents and balconies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/kcspaces-Prairie-Fire-30.jpg"
    },
    {
      "id": "ec_95d2aef4d5473593f992bf52",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-bdb3-73a1-b812-7f02a711932c.webp",
      "image_media": {
        "alt_text": "Entrance to the leasing center with the number 5750 above the door.",
        "public_id": "01a0c4a9-bdb3-73a1-b812-7f02a711932c",
        "storage_key": "property/6767906449167620/01a0c4a9-bdb3-73a1-b812-7f02a711932c.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Welcome to the leasing center, your first stop for finding your new home.",
      "link": "false",
      "alt_text": "Entrance to the leasing center with the number 5750 above the door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/kcspaces-Prairie-Fire-19(1).jpg"
    },
    {
      "id": "ec_3ce76b4f28417bc1c8477d6b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-bc58-73d8-af84-24e222ffb4cf.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex with a swimming pool and surrounding buildings.",
        "public_id": "01a0c4a9-bc58-73d8-af84-24e222ffb4cf",
        "storage_key": "property/6767906449167620/01a0c4a9-bc58-73d8-af84-24e222ffb4cf.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover resort-style living at our apartment community, featuring a sparkling swimming pool and beautiful grounds.",
      "link": "false",
      "alt_text": "Aerial view of apartment complex with a swimming pool and surrounding buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 07.jpg"
    },
    {
      "id": "ec_8112f62eb7847dbe33fa5765",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-baf3-7068-89b5-fce4e9d17e90.webp",
      "image_media": {
        "alt_text": "Residences at Prairiefire Apartment Homes monument sign with apartment building in the background",
        "public_id": "01a0c4a9-baf3-7068-89b5-fce4e9d17e90",
        "storage_key": "property/6767906449167620/01a0c4a9-baf3-7068-89b5-fce4e9d17e90.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Welcome to Residences at Prairiefire Apartment Homes, featuring modern living spaces and community amenities.",
      "link": "false",
      "alt_text": "Residences at Prairiefire Apartment Homes monument sign with apartment building in the background",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Prairie Fire - 41.jpg"
    },
    {
      "id": "ec_eaf78617a7b4625efa9c8673",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-c045-761a-b709-0a4ca42fd34a.webp",
      "image_media": {
        "alt_text": "Exterior of a modern apartment building with balconies and parking.",
        "public_id": "01a0c4a9-c045-761a-b709-0a4ca42fd34a",
        "storage_key": "property/6767906449167620/01a0c4a9-c045-761a-b709-0a4ca42fd34a.webp",
        "width": 966,
        "height": 629
      },
      "title": "Community",
      "description": "A contemporary apartment building featuring multiple stories, balconies, and ample parking, set against a backdrop of a bright, cloudy sky.",
      "link": "false",
      "alt_text": "Exterior of a modern apartment building with balconies and parking.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/bldgs.JPG"
    },
    {
      "id": "ec_210fb495380b8df9c4dda879",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-d257-7566-976f-9052dd985a5b.webp",
      "image_media": {
        "alt_text": "Resort-style pool with lounge chairs and umbrellas, featuring a multi-tiered fountain.",
        "public_id": "01a0c4a9-d257-7566-976f-9052dd985a5b",
        "storage_key": "property/6767906449167620/01a0c4a9-d257-7566-976f-9052dd985a5b.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax and unwind by our sparkling resort-style pool, complete with a beautiful tiered fountain and ample lounge seating for your ultimate comfort.",
      "link": "false",
      "alt_text": "Resort-style pool with lounge chairs and umbrellas, featuring a multi-tiered fountain.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (11).jpg"
    },
    {
      "id": "ec_06612cd30808aa2130b899ab",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-cdcf-7573-89a8-dbace0f51105.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a fireplace and two televisions.",
        "public_id": "01a0c4a9-cdcf-7573-89a8-dbace0f51105",
        "storage_key": "property/6767906449167620/01a0c4a9-cdcf-7573-89a8-dbace0f51105.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Relax in our stylish lounge, complete with a cozy fireplace and entertainment options.",
      "link": "false",
      "alt_text": "Modern lounge area with a fireplace and two televisions.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (5).jpg"
    },
    {
      "id": "ec_6da644b3079c8b258e64ea32",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-ea5c-7661-b07d-b88ecb2416bd.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with seating, TV, and fireplace.",
        "public_id": "01a0c4a9-ea5c-7661-b07d-b88ecb2416bd",
        "storage_key": "property/6767906449167620/01a0c4a9-ea5c-7661-b07d-b88ecb2416bd.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy the outdoors in our covered lounge area, complete with a fireplace, outdoor TVs, and comfortable seating.",
      "link": "false",
      "alt_text": "Outdoor lounge area with seating, TV, and fireplace.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (8).jpg"
    },
    {
      "id": "ec_657ba5db7e58056096b2d031",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-dc5f-7448-88c0-cce17db70bcf.webp",
      "image_media": {
        "alt_text": "Business center with computers and seating",
        "public_id": "01a0c4a9-dc5f-7448-88c0-cce17db70bcf",
        "storage_key": "property/6767906449167620/01a0c4a9-dc5f-7448-88c0-cce17db70bcf.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Stay productive in our convenient business center, equipped with computers, printers, and comfortable seating.",
      "link": "false",
      "alt_text": "Business center with computers and seating",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (4).jpg"
    },
    {
      "id": "ec_b67fc6b4105b53816529df1d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-e6db-768a-9276-c122661fd6da.webp",
      "image_media": {
        "alt_text": "Outdoor kitchen with grills and seating area at an apartment complex.",
        "public_id": "01a0c4a9-e6db-768a-9276-c122661fd6da",
        "storage_key": "property/6767906449167620/01a0c4a9-e6db-768a-9276-c122661fd6da.webp",
        "width": 3072,
        "height": 2051
      },
      "title": "Community",
      "description": "Enjoy al fresco dining with our built-in outdoor kitchen and comfortable seating area, perfect for entertaining guests or relaxing with family.",
      "link": "false",
      "alt_text": "Outdoor kitchen with grills and seating area at an apartment complex.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (6).jpg"
    },
    {
      "id": "ec_dff27cd4f65fb363170554af",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-f6de-741b-8d71-3c5d15da97ea.webp",
      "image_media": {
        "alt_text": "Car care center with car wash vacuum and a red car.",
        "public_id": "01a0c4a9-f6de-741b-8d71-3c5d15da97ea",
        "storage_key": "property/6767906449167620/01a0c4a9-f6de-741b-8d71-3c5d15da97ea.webp",
        "width": 3072,
        "height": 2043
      },
      "title": "Community",
      "description": "Convenient on-site car care center with vacuum and wash amenities, making it easy to keep your vehicle pristine.",
      "link": "false",
      "alt_text": "Car care center with car wash vacuum and a red car.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (7).jpg"
    },
    {
      "id": "ec_de9edbff3829b4177b69c444",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-eb30-71be-9be0-41013b63b95d.webp",
      "image_media": {
        "alt_text": "State-of-the-art fitness center with treadmills, ellipticals, and a cable crossover machine.",
        "public_id": "01a0c4a9-eb30-71be-9be0-41013b63b95d",
        "storage_key": "property/6767906449167620/01a0c4a9-eb30-71be-9be0-41013b63b95d.webp",
        "width": 1355,
        "height": 1016
      },
      "title": "Community",
      "description": "Stay active and energized in our fully equipped fitness center, featuring a variety of cardio and strength training equipment for a complete workout.",
      "link": "false",
      "alt_text": "State-of-the-art fitness center with treadmills, ellipticals, and a cable crossover machine.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (3).jpg"
    },
    {
      "id": "ec_ec0886cd03e5d3ed1ee30644",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4a9-fb25-74ad-8554-5181c7a97789.webp",
      "image_media": {
        "alt_text": "Wrapping station with rolls of paper, ribbons, and craft supplies.",
        "public_id": "01a0c4a9-fb25-74ad-8554-5181c7a97789",
        "storage_key": "property/6767906449167620/01a0c4a9-fb25-74ad-8554-5181c7a97789.webp",
        "width": 1251,
        "height": 1016
      },
      "title": "Other",
      "description": "This dedicated wrapping station is fully equipped with all the supplies you need to prepare gifts and packages, adding a touch of convenience to your everyday life.",
      "link": "false",
      "alt_text": "Wrapping station with rolls of paper, ribbons, and craft supplies.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (2).jpg"
    },
    {
      "id": "ec_51d01a3899410ccd7571113b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-0108-701d-9e31-8a268f67e30a.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and pergolas.",
        "public_id": "01a0c4aa-0108-701d-9e31-8a268f67e30a",
        "storage_key": "property/6767906449167620/01a0c4aa-0108-701d-9e31-8a268f67e30a.webp",
        "width": 1025,
        "height": 607
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our resort-style swimming pool, surrounded by comfortable lounge chairs and shaded pergolas for ultimate relaxation.",
      "link": "false",
      "alt_text": "Resort-style swimming pool with lounge chairs and pergolas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/Amenities (10).JPG"
    },
    {
      "id": "ec_9886ddb46050a446294ef590",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-0a12-73a6-86ea-49b0fa648942.webp",
      "image_media": {
        "alt_text": "The Museum at Prairiefire exterior with colorful glass facade and dramatic sky.",
        "public_id": "01a0c4aa-0a12-73a6-86ea-49b0fa648942",
        "storage_key": "property/6767906449167620/01a0c4aa-0a12-73a6-86ea-49b0fa648942.webp",
        "width": 1524,
        "height": 1016
      },
      "title": "Community",
      "description": "Experience the striking architecture of the Museum at Prairiefire, featuring a vibrant, multi-colored glass exterior that glows against a dramatic sunset sky.",
      "link": "false",
      "alt_text": "The Museum at Prairiefire exterior with colorful glass facade and dramatic sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839275.jpg"
    },
    {
      "id": "ec_de1335a79db0cf5e71575b90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-1239-727f-8391-942619d48bb5.webp",
      "image_media": {
        "alt_text": "People practicing yoga on the lawn in front of a modern building.",
        "public_id": "01a0c4aa-1239-727f-8391-942619d48bb5",
        "storage_key": "property/6767906449167620/01a0c4aa-1239-727f-8391-942619d48bb5.webp",
        "width": 1016,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "Enjoy a refreshing yoga session on the green lawn, surrounded by nature and modern architecture. A perfect way to de-stress and connect with your inner peace.",
      "link": "false",
      "alt_text": "People practicing yoga on the lawn in front of a modern building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/45823153.jpg"
    },
    {
      "id": "ec_dab1de3230b1a8b80c17e8aa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-1fcc-71ea-8159-8d1a5dd2a905.webp",
      "image_media": {
        "alt_text": "A group of cyclists gather in front of a building with parked cars.",
        "public_id": "01a0c4aa-1fcc-71ea-8159-8d1a5dd2a905",
        "storage_key": "property/6767906449167620/01a0c4aa-1fcc-71ea-8159-8d1a5dd2a905.webp",
        "width": 1524,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "A vibrant community event featuring cyclists ready to explore the area. Enjoy active living and connect with neighbors.",
      "link": "false",
      "alt_text": "A group of cyclists gather in front of a building with parked cars.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839280.jpg"
    },
    {
      "id": "ec_b2ca7f3c49a892a7ba5487f6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-20e0-711e-a013-665bf5a17383.webp",
      "image_media": {
        "alt_text": "Restaurant interior with diners at tables and a bar area.",
        "public_id": "01a0c4aa-20e0-711e-a013-665bf5a17383",
        "storage_key": "property/6767906449167620/01a0c4aa-20e0-711e-a013-665bf5a17383.webp",
        "width": 1502,
        "height": 1016
      },
      "title": "Community",
      "description": "Diners enjoy a meal in a bustling restaurant with unique bottle chandeliers and a rustic interior design.",
      "link": "false",
      "alt_text": "Restaurant interior with diners at tables and a bar area.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839273.jpg"
    },
    {
      "id": "ec_127a14b9a372deaf06a052ff",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-21df-73b9-9e06-140637b21e57.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with a gas fireplace at dusk, with people relaxing and conversing.",
        "public_id": "01a0c4aa-21df-73b9-9e06-140637b21e57",
        "storage_key": "property/6767906449167620/01a0c4aa-21df-73b9-9e06-140637b21e57.webp",
        "width": 1524,
        "height": 1016
      },
      "title": "Community",
      "description": "Enjoy the evening air in our beautifully designed outdoor lounge, complete with a modern gas fireplace and comfortable seating. Perfect for socializing or unwinding.",
      "link": "false",
      "alt_text": "Outdoor seating area with a gas fireplace at dusk, with people relaxing and conversing.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839277.jpg"
    },
    {
      "id": "ec_7ad4c47869843108b9b179c3",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-229a-77b5-ab10-6d9c18ee9f2d.webp",
      "image_media": {
        "alt_text": "Group of cyclists ready for a ride outside a modern building.",
        "public_id": "01a0c4aa-229a-77b5-ab10-6d9c18ee9f2d",
        "storage_key": "property/6767906449167620/01a0c4aa-229a-77b5-ab10-6d9c18ee9f2d.webp",
        "width": 1364,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "Join our vibrant community and participate in local events and activities, like this group cycling event. Perfect for an active and social lifestyle.",
      "link": "false",
      "alt_text": "Group of cyclists ready for a ride outside a modern building.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839279.jpg"
    },
    {
      "id": "ec_dfc0d97eb4a4f83105d4a330",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-2239-7519-b902-c6406836ce9b.webp",
      "image_media": {
        "alt_text": "Cinetopia movie theater exterior and parking lot at sunset.",
        "public_id": "01a0c4aa-2239-7519-b902-c6406836ce9b",
        "storage_key": "property/6767906449167620/01a0c4aa-2239-7519-b902-c6406836ce9b.webp",
        "width": 1611,
        "height": 1016
      },
      "title": "Community",
      "description": "Modern Cinetopia movie theater building with contemporary architecture, large windows, and a prominent sign. The image captures the exterior and a parking lot filled with cars during a beautiful sunset, highlighting the entertainment venue's inviting atmosphere.",
      "link": "false",
      "alt_text": "Cinetopia movie theater exterior and parking lot at sunset.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839282.jpg"
    },
    {
      "id": "ec_0a60850e1746abdfb5073541",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-2f12-742d-b5ee-d77d93ac09cc.webp",
      "image_media": {
        "alt_text": "People watching a movie in a theater wearing 3D glasses.",
        "public_id": "01a0c4aa-2f12-742d-b5ee-d77d93ac09cc",
        "storage_key": "property/6767906449167620/01a0c4aa-2f12-742d-b5ee-d77d93ac09cc.webp",
        "width": 1524,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "Enjoy a cinematic experience in our state-of-the-art movie theater, perfect for a relaxing night in or entertaining guests.",
      "link": "false",
      "alt_text": "People watching a movie in a theater wearing 3D glasses.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839276.jpg"
    },
    {
      "id": "ec_62806ee266b7da0d6b269ce0",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-303a-739e-a150-53b442ab1ee0.webp",
      "image_media": {
        "alt_text": "Two glasses of wine being toasted over pizzas on a red and white checkered tablecloth.",
        "public_id": "01a0c4aa-303a-739e-a150-53b442ab1ee0",
        "storage_key": "property/6767906449167620/01a0c4aa-303a-739e-a150-53b442ab1ee0.webp",
        "width": 1524,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "Enjoy a delightful meal with a glass of wine, perfect for a relaxing evening.",
      "link": "false",
      "alt_text": "Two glasses of wine being toasted over pizzas on a red and white checkered tablecloth.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839274.jpg"
    },
    {
      "id": "ec_504705332b70ab50a7cd648d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-3250-7566-9dbf-e8a30424047f.webp",
      "image_media": {
        "alt_text": "Dog looking at pizza on a table.",
        "public_id": "01a0c4aa-3250-7566-9dbf-e8a30424047f",
        "storage_key": "property/6767906449167620/01a0c4aa-3250-7566-9dbf-e8a30424047f.webp",
        "width": 1398,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "A dog waits patiently by a table, hoping for a bite of pizza.",
      "link": "false",
      "alt_text": "Dog looking at pizza on a table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839281.jpg"
    },
    {
      "id": "ec_9999a7cb41d4052929ad5c3f",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-34e7-75b3-9723-8580f719d329.webp",
      "image_media": {
        "alt_text": "Three bloody mary cocktails with garnishes and a side of crudités.",
        "public_id": "01a0c4aa-34e7-75b3-9723-8580f719d329",
        "storage_key": "property/6767906449167620/01a0c4aa-34e7-75b3-9723-8580f719d329.webp",
        "width": 1365,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "Enjoy these refreshing bloody marys, perfect for brunch or a special occasion. Served with a side of fresh carrots, celery, and bell peppers.",
      "link": "false",
      "alt_text": "Three bloody mary cocktails with garnishes and a side of crudités.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839283.png"
    },
    {
      "id": "ec_d71a894f2c65d7e99ac0e53b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-3575-7386-ac31-8a4124991a1d.webp",
      "image_media": {
        "alt_text": "People enjoying an outdoor concert with a live band playing music and a singer.",
        "public_id": "01a0c4aa-3575-7386-ac31-8a4124991a1d",
        "storage_key": "property/6767906449167620/01a0c4aa-3575-7386-ac31-8a4124991a1d.webp",
        "width": 1524,
        "height": 1016
      },
      "title": "Lifestyle",
      "description": "Gather your friends and family for an evening of entertainment. Enjoy live music performances in our vibrant community spaces.",
      "link": "false",
      "alt_text": "People enjoying an outdoor concert with a live band playing music and a singer.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/5458/66839278.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_ac58f9ab-d9a4-4402-99f2-6402ec550063",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "The Brass Onion",
      "poi_type": "Restaurants",
      "poi_address": "5501 W 135th St, Overland Park, KS 66224, USA",
      "poi_short_description": "Mall-based spot with a lengthy menu of pub grub & comfort foods plus weekend brunch & full bar.",
      "poi_long_description": "Mall-based spot with a lengthy menu of pub grub & comfort foods plus weekend brunch & full bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc992-e0d9-757d-b5b1-c809d8d5442a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-e0d9-757d-b5b1-c809d8d5442a",
        "storage_key": "property/6767906449167620/019fc992-e0d9-757d-b5b1-c809d8d5442a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://thebrassonion.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17421562907293316797&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-brass-onion",
      "poi_latitude": "38.8832383",
      "poi_longitude": "-94.6501144",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-851-5940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeyizPDBwIcRvfZWKSnTxfE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_9d248c86-e5f4-4f17-8e90-8fa6ae3578c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Veritas Whiskey and Wine Grill",
      "poi_type": "Restaurants",
      "poi_address": "5621 W 135th St Ste 2620, Overland Park, KS 66223, USA",
      "poi_short_description": "Restaurant serving brunch, lunch and dinner alongside craft cocktails and a wine selection.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc992-d892-70af-9d7d-172d6fb81719.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-d892-70af-9d7d-172d6fb81719",
        "storage_key": "property/6767906449167620/019fc992-d892-70af-9d7d-172d6fb81719.webp",
        "width": 926,
        "height": 806
      },
      "poi_business_url": "http://veritaskc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11216570818203659628&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "veritas-whiskey-and-wine-grill",
      "poi_latitude": "38.8828245",
      "poi_longitude": "-94.6505221",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-291-0504",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg8tEd_7BwIcRbK0KMbtDqZs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_42fd2dd2-49f3-45e4-b243-a25f00e367cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Rajmahal Indian Cuisine and Bar",
      "poi_type": "Restaurants",
      "poi_address": "5621 W 135th St Ste 2610, Overland Park, KS 66223, USA",
      "poi_short_description": "Contemporary locale for familiar Indian food, such as curries, tandoori dishes & biriyanis.",
      "poi_long_description": "Contemporary locale for familiar Indian food, such as curries, tandoori dishes & biriyanis.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc992-f322-735c-a420-719b3fe35f70.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-f322-735c-a420-719b3fe35f70",
        "storage_key": "property/6767906449167620/019fc992-f322-735c-a420-719b3fe35f70.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rajindiankc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3360016778443378904&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rajmahal-indian-cuisine-and-bar",
      "poi_latitude": "38.88283",
      "poi_longitude": "-94.6503674",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-645-1420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJI4paqX3BwIcR2FB4NnUtoS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_dc6f6bab-1b82-4612-9fde-6162485f151a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Grimaldi's Pizzeria",
      "poi_type": "Restaurants",
      "poi_address": "5601 W 135th St Suite 2240, Overland Park, KS 66224, USA",
      "poi_short_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_long_description": "Casual, Brooklyn-based pizzeria chain serving brick-oven pies & calzones, plus wine & beer.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-fc01-7301-b749-33d44bd11dcf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-fc01-7301-b749-33d44bd11dcf",
        "storage_key": "property/6767906449167620/019fc993-fc01-7301-b749-33d44bd11dcf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.grimaldispizzeria.com/locations/prairiefire/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11892796518695667969&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "grimaldis-pizzeria",
      "poi_latitude": "38.8832213",
      "poi_longitude": "-94.650748",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-851-5062",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3bEPxvDBwIcRAYnbSmyzC6U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_46875e6f-8aaf-405e-82a1-0ebe57b49190",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Chicken N Pickle - Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "5901 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly venue with pickleball courts and other games, plus a casual restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-eacc-76bd-89c4-47eba6100fab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-eacc-76bd-89c4-47eba6100fab",
        "storage_key": "property/6767906449167620/019fc993-eacc-76bd-89c4-47eba6100fab.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://chickennpickle.com/location/overland-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3904135511973972812&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chicken-n-pickle---overland-park",
      "poi_latitude": "38.8830518",
      "poi_longitude": "-94.6552102",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-703-5950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJQ9D8rijBwIcRTEsyKpBGLjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_37b8269d-74c8-4c60-8e99-196b28f3dbd4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Nick & Jake's Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "6830 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Local bar & grill chain serving classic American fare, pasta, burgers & global bites.",
      "poi_long_description": "Local bar & grill chain serving classic American fare, pasta, burgers & global bites.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0100a-f777-75db-93b9-c7065ba02a40.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-f777-75db-93b9-c7065ba02a40",
        "storage_key": "property/6767906449167620/01a0100a-f777-75db-93b9-c7065ba02a40.webp",
        "width": 975,
        "height": 1233
      },
      "poi_business_url": "http://www.nickandjakes.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1372827290254850032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nick--jakes-overland-park",
      "poi_latitude": "38.8843201",
      "poi_longitude": "-94.6646491",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-681-8535",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJexsdCujBwIcR8DeanSVDDRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_d366a0d7-efe8-4b7f-8973-79d6d1c27de5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "YaYas Euro Bistro in Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "7021 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Hand-tossed, oak-fired pizza & other Mediterranean eats are served at this woodsy-chic bar & eatery.",
      "poi_long_description": "Hand-tossed, oak-fired pizza & other Mediterranean eats are served at this woodsy-chic bar & eatery.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0100a-f291-76f9-861f-cc7ce94f9457.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-f291-76f9-861f-cc7ce94f9457",
        "storage_key": "property/6767906449167620/01a0100a-f291-76f9-861f-cc7ce94f9457.webp",
        "width": 800,
        "height": 800
      },
      "poi_business_url": "http://overlandpark.yayaseurobistro.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9704134031630427705&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yayas-euro-bistro-in-overland-park",
      "poi_latitude": "38.8818901",
      "poi_longitude": "-94.6661847",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-345-1111",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJy0tvCPTpwIcROWYcsHwCrIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "european_restaurant"
    },
    {
      "id": "custom_7f5ed399-7b99-400f-82c4-85efd3b44d5b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Snooze, an A.M. Eatery",
      "poi_type": "Restaurants",
      "poi_address": "7012 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_long_description": "Vibrant, retro chain serving a seasonal menu of creative breakfast & lunch fare, plus cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-0d00-759d-89a1-6f44251a0a66.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-0d00-759d-89a1-6f44251a0a66",
        "storage_key": "property/6767906449167620/019fc993-0d00-759d-89a1-6f44251a0a66.webp",
        "width": 1280,
        "height": 793
      },
      "poi_business_url": "https://www.snoozeeatery.com/restaurant/kansas/overland-park/?utm_source=Google&utm_medium=BusinessListing",
      "poi_directions_map_url": "https://maps.google.com/?cid=1196182886128371952&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "snooze-an-am-eatery",
      "poi_latitude": "38.8841523",
      "poi_longitude": "-94.6672714",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-349-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJaXt2i_7BwIcR8EgVTv-xmRA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_e287f041-b827-4884-8ec0-e62ce92096e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Dutch Bros Coffee",
      "poi_type": "Restaurants",
      "poi_address": "5851 W 135th St \"Prairie Fire Development, Overland Park, KS 66223, USA",
      "poi_short_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_long_description": "Fun-loving drive-thru serving up customized coffees, Rebel energy drinks, cold brew, tea & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc992-d9cc-755f-8948-dc34165d3742.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-d9cc-755f-8948-dc34165d3742",
        "storage_key": "property/6767906449167620/019fc992-d9cc-755f-8948-dc34165d3742.webp",
        "width": 959,
        "height": 1280
      },
      "poi_business_url": "https://www.dutchbros.com/locations/ks/overland-park/5851-w-135th-st?y_source=1_MjAzMTI4MDAzMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=11655255897202443077&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dutch-bros-coffee",
      "poi_latitude": "38.8830753",
      "poi_longitude": "-94.6537208",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 877-899-2767",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1bba-7449-91d2-98a3129572dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1bba-7449-91d2-98a3129572dd",
        "storage_key": "property/6767906449167620/019ff6a4-1bba-7449-91d2-98a3129572dd.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJk-dP1J_BwIcRRUMHf3zJv6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_19fc2fb3-48d7-413d-afa0-f0d2c99ed16b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Andy's Frozen Custard",
      "poi_type": "Restaurants",
      "poi_address": "5821 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_long_description": "Frozen custard sundaes, concretes & more, plus a choice of toppings (with a drive-thru window).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc992-e58e-7283-b47f-1dbecc4736cf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc992-e58e-7283-b47f-1dbecc4736cf",
        "storage_key": "property/6767906449167620/019fc992-e58e-7283-b47f-1dbecc4736cf.webp",
        "width": 1123,
        "height": 1280
      },
      "poi_business_url": "https://locations.eatandys.com/ll/US/KS/Overland-Park/5821-W-135th%20St",
      "poi_directions_map_url": "https://maps.google.com/?cid=12214543236411097325&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "andys-frozen-custard",
      "poi_latitude": "38.8832196",
      "poi_longitude": "-94.6531221",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "5 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-392-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ-UbXjRzBwIcR7QDvq1vGgqk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "dessert_shop"
    },
    {
      "id": "custom_e166010c-85c4-4060-93b4-f4fc71da8ee3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "The Brew Top Pub and Patio",
      "poi_type": "Restaurants",
      "poi_address": "6601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Sizable, easygoing hangout with a patio offering pub grub, a large beer selection & live music.",
      "poi_long_description": "Sizable, easygoing hangout with a patio offering pub grub, a large beer selection & live music.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-32b4-731b-949a-71edba41970e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-32b4-731b-949a-71edba41970e",
        "storage_key": "property/6767906449167620/01a0c4ab-32b4-731b-949a-71edba41970e.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.thebrewtop.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=683704552941770679&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-brew-top-pub-and-patio",
      "poi_latitude": "38.8810941",
      "poi_longitude": "-94.6620258",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-897-5500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWcCvoOnBwIcRt1dpIasBfQk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_bb548a98-79c0-4415-b8b3-a351bc2311c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Talk of the Town Grill & Bar",
      "poi_type": "Restaurants",
      "poi_address": "5201 W 135th St, Leawood, KS 66224, USA",
      "poi_short_description": "Casual sports bar featuring burgers, waffles fries, and happy-hour specials, plus a patio.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-008b-739e-818f-6db5644bc4e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-008b-739e-818f-6db5644bc4e0",
        "storage_key": "property/6767906449167620/019fc993-008b-739e-818f-6db5644bc4e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.talkofthetowngrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14903259101649019219&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "talk-of-the-town-grill--bar",
      "poi_latitude": "38.8832998",
      "poi_longitude": "-94.6475091",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-851-7444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJP8m7CffBwIcRU6FlLTED084",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar_and_grill"
    },
    {
      "id": "custom_8a5f60ff-dafd-4342-82fa-91a029e85615",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "810 Entertainment - Overland Park",
      "poi_type": "Entertainment",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-329a-7051-8571-ed405c628647.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-329a-7051-8571-ed405c628647",
        "storage_key": "property/6767906449167620/01a0c4ab-329a-7051-8571-ed405c628647.webp",
        "width": 853,
        "height": 1280
      },
      "poi_business_url": "https://810bowling.com/810-entertainment-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=11623012279752903673&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "810-entertainment---overland-park",
      "poi_latitude": "38.8828352",
      "poi_longitude": "-94.6497927",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-600-7088",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ298S-n_BwIcR-cusShY8TaE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "event_venue"
    },
    {
      "id": "custom_5a1678a2-180d-4db2-97a1-72a0b1436677",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Goodcents",
      "poi_type": "Restaurants",
      "poi_address": "6760 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Cold & hot subs, pastas & salads fill out the menu at this simple, counter-serve chain.",
      "poi_long_description": "Cold & hot subs, pastas & salads fill out the menu at this simple, counter-serve chain.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-3485-74bf-814e-48ca1770ac1c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-3485-74bf-814e-48ca1770ac1c",
        "storage_key": "property/6767906449167620/01a0c4ab-3485-74bf-814e-48ca1770ac1c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.goodcentssubs.com/en-us/us/ks/overland-park/6760-w-135th-st/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14755922810119313821&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "goodcents",
      "poi_latitude": "38.885445",
      "poi_longitude": "-94.66376",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-402-9191",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWZAKcejBwIcRndk-lp2Rx8w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sandwich_shop"
    },
    {
      "id": "custom_5c66f1ae-4cd3-4cf9-80d9-fb2eeedd419c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Louie's Wine Dive and Kitchen 119",
      "poi_type": "Restaurants",
      "poi_address": "6701 W 119th St, Overland Park, KS 66209, USA",
      "poi_short_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_long_description": "Comfortable destination known for locally sourced comfort food & an extensive wine list.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-328d-7512-9c77-41912ac18fac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-328d-7512-9c77-41912ac18fac",
        "storage_key": "property/6767906449167620/01a0c4ab-328d-7512-9c77-41912ac18fac.webp",
        "width": 1024,
        "height": 682
      },
      "poi_business_url": "https://www.louieswinedive.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17363784540288348534&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "louies-wine-dive-and-kitchen-119",
      "poi_latitude": "38.9123445",
      "poi_longitude": "-94.6636772",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-469-4177",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-55e3-75f9-aace-90f93087fa5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-55e3-75f9-aace-90f93087fa5f",
        "storage_key": "property/6767906449167620/01a0c4ab-55e3-75f9-aace-90f93087fa5f.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGUqh8BTqwIcRdnFOyAqO-PA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "wine_bar"
    },
    {
      "id": "custom_681d4378-2e0b-48cf-9730-b71ff583f75e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Sprouts Farmers Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6821 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_long_description": "Specialty chain offering a range of natural & organic grocery items, including own-brand goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-52df-76bd-b246-b621d42b588c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-52df-76bd-b246-b621d42b588c",
        "storage_key": "property/6767906449167620/019fc993-52df-76bd-b246-b621d42b588c.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://sprouts.com/store/ks/overland-park/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=5833230487850233402&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sprouts-farmers-market",
      "poi_latitude": "38.8822002",
      "poi_longitude": "-94.6654118",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-643-4190",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-8edd04f06aa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-8edd04f06aa4",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-8edd04f06aa4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_6uqgcLBwIcROq5KETnM81A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_22f56daa-86e0-4cb7-a30b-0c2c0956d003",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Hen House Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "6900 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Casual market, deli and supermarket with fresh produce and a large meat section along with a florist, a bakery, a cafe, prepared foods and bagels.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-1fd7-7211-b51d-15d23a09f56e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-1fd7-7211-b51d-15d23a09f56e",
        "storage_key": "property/6767906449167620/019fc993-1fd7-7211-b51d-15d23a09f56e.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://henhouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3407519095472349622&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hen-house-market",
      "poi_latitude": "38.8856924",
      "poi_longitude": "-94.6657055",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-685-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-8edd04f06aa4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-8edd04f06aa4",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-8edd04f06aa4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIbLSX93BwIcRtmH9QpDwSS8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5e3bfd27-04fc-4e36-a0d7-9636e0a2c36c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "REI",
      "poi_type": "Shopping & Retail",
      "poi_address": "6281 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_long_description": "Retail chain carrying gear, apparel & footwear for a wide range of outdoor & fitness activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-3bc5-72c0-834f-4a66043ceb2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-3bc5-72c0-834f-4a66043ceb2f",
        "storage_key": "property/6767906449167620/019fc993-3bc5-72c0-834f-4a66043ceb2f.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.rei.com/stores/overland-park?y_source=1_MTQ1MzQ2NS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=2425922740833547199&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rei",
      "poi_latitude": "38.8829948",
      "poi_longitude": "-94.6579242",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-402-1938",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJw6_qcX_VxocRv_PsM-GbqiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_556f08cf-c04a-4f18-90e3-0f0242f236a5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "6261 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-3c2b-74bf-a4d0-b0cb637cdebe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-3c2b-74bf-a4d0-b0cb637cdebe",
        "storage_key": "property/6767906449167620/019fc993-3c2b-74bf-a4d0-b0cb637cdebe.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1173931942477054990&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "38.8822661",
      "poi_longitude": "-94.6569814",
      "poi_miles_from_property": "0.3",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-400-2558",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZyl1Cu_BwIcRDkTUxeGkShA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_764dae46-9b3d-4025-95e8-e7d06d2d4a89",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Scheels",
      "poi_type": "Shopping & Retail",
      "poi_address": "6503 W 135th St STE 88, Overland Park, KS 66223, USA",
      "poi_short_description": "Chain with apparel, shoes & gear for sports & outdoor recreation, plus merchandise with team logos.",
      "poi_long_description": "Chain with apparel, shoes & gear for sports & outdoor recreation, plus merchandise with team logos.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-38bc-703e-afa9-34cf8355def2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-38bc-703e-afa9-34cf8355def2",
        "storage_key": "property/6767906449167620/01a0c4ab-38bc-703e-afa9-34cf8355def2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.scheels.com/store/overland-park/088?utm_source=google&utm_medium=yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=1094253745788337078&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "scheels",
      "poi_latitude": "38.8804238",
      "poi_longitude": "-94.6607748",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-897-3030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvUOZyt7BwIcRtrva8_uRLw8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_dd103d27-8105-4dad-9193-69a29192c290",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Von Maur",
      "poi_type": "Shopping & Retail",
      "poi_address": "Corbin Park, 6701 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Department-store chain stocking brand-name clothing, jewelry & home accessories.",
      "poi_long_description": "Department-store chain stocking brand-name clothing, jewelry & home accessories.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-36c2-72df-b84b-1bfe94cc13d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-36c2-72df-b84b-1bfe94cc13d1",
        "storage_key": "property/6767906449167620/01a0c4ab-36c2-72df-b84b-1bfe94cc13d1.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "http://www.vonmaur.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3681408238694131425&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "von-maur",
      "poi_latitude": "38.8818734",
      "poi_longitude": "-94.6632437",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-681-1031",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ2ZhAVujBwIcR4WaPxEn9FjM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_a279b00e-8c2f-4267-abee-5b5aa3e74b73",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Toner Jewelers",
      "poi_type": "Shopping & Retail",
      "poi_address": "6285 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Local fine jewelry store offering diamond engagement rings, estate pieces & pre-owned Rolex watches.",
      "poi_long_description": "Local fine jewelry store offering diamond engagement rings, estate pieces & pre-owned Rolex watches.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-3928-777d-b35c-3e764346f1e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-3928-777d-b35c-3e764346f1e6",
        "storage_key": "property/6767906449167620/01a0c4ab-3928-777d-b35c-3e764346f1e6.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://tonerjewelers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9693077200855804932&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "toner-jewelers",
      "poi_latitude": "38.8819123",
      "poi_longitude": "-94.6581118",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-663-3092",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJZzz2hyaVwIcRBKxyqVu6hIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "jewelry_store"
    },
    {
      "id": "custom_481730d0-9b08-4da8-85c8-f42adafdfae6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Fat Brain Toys",
      "poi_type": "Shopping & Retail",
      "poi_address": "5601 W 135th St #2230, Overland Park, KS 66224, USA",
      "poi_short_description": "Educational toy store stocking products for all ages and hosting free events for young children.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a3-bffc-74be-8dc0-ddbb29cf28e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-bffc-74be-8dc0-ddbb29cf28e8",
        "storage_key": "property/6767906449167620/019ff6a3-bffc-74be-8dc0-ddbb29cf28e8.webp",
        "width": 1280,
        "height": 938
      },
      "poi_business_url": "https://www.fatbraintoys.com/about_us/kansas_city_toy_store.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=10217286617004241700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fat-brain-toys",
      "poi_latitude": "38.8832458",
      "poi_longitude": "-94.6509887",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 913-305-4894",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWbW2uPDBwIcRJPPjbgsYy40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "toy_store"
    },
    {
      "id": "custom_d274232a-8116-4a86-adf5-967122817fe3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Threshing Bee",
      "poi_type": "Shopping & Retail",
      "poi_address": "5621 W 135th St #2630, Overland Park, KS 66223, USA",
      "poi_short_description": "Retail space combining several small boutiques for women's clothing, shoes, jewelry & gifts.",
      "poi_long_description": "Retail space combining several small boutiques for women's clothing, shoes, jewelry & gifts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-5d0c-725b-b038-156ed5e64b9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-5d0c-725b-b038-156ed5e64b9d",
        "storage_key": "property/6767906449167620/019fc993-5d0c-725b-b038-156ed5e64b9d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://threshingbee.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2601110922432688501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "threshing-bee",
      "poi_latitude": "38.8828346",
      "poi_longitude": "-94.6509953",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-400-2497",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJWeyizPDBwIcRdTH9SJoAGSQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "clothing_store"
    },
    {
      "id": "custom_35f3d046-86f1-4092-80b4-32a21246d578",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "8300 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-1789-7538-b6b4-0b624d0e1001.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-1789-7538-b6b4-0b624d0e1001",
        "storage_key": "property/6767906449167620/019fc993-1789-7538-b6b4-0b624d0e1001.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.samsclub.com/club/4707-overland-park-ks",
      "poi_directions_map_url": "https://maps.google.com/?cid=13205436472745682803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sams-club",
      "poi_latitude": "38.8863478",
      "poi_longitude": "-94.6830744",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-402-1405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-50fcebf4cead",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-50fcebf4cead.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJtbHmBtLBwIcRc2f-rYEiQ7c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_62a7a349-e7be-4030-91ae-d8d5be47c6ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Overland Trail Elementary School",
      "poi_type": "Education",
      "poi_address": "6225 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-8616-755c-bf5d-c1d0110c27b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-8616-755c-bf5d-c1d0110c27b4",
        "storage_key": "property/6767906449167620/019fc993-8616-755c-bf5d-c1d0110c27b4.webp",
        "width": 1280,
        "height": 861
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTE",
      "poi_directions_map_url": "https://maps.google.com/?cid=2244344860322751896&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-elementary-school",
      "poi_latitude": "38.88582210000001",
      "poi_longitude": "-94.6575254",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRmOUCacKDJR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d26142cc-4015-4ac4-8746-82caa6b8697e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Overland Trail Middle School",
      "poi_type": "Education",
      "poi_address": "6201 W 133rd St, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-7470-719e-9fdd-53c2552a8e6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-7470-719e-9fdd-53c2552a8e6e",
        "storage_key": "property/6767906449167620/019fc993-7470-719e-9fdd-53c2552a8e6e.webp",
        "width": 1280,
        "height": 543
      },
      "poi_business_url": "https://www.bluevalleyk12.org/OTM",
      "poi_directions_map_url": "https://maps.google.com/?cid=15599445353126869038&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-trail-middle-school",
      "poi_latitude": "38.8855363",
      "poi_longitude": "-94.6545605",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-239-5400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJy1sTYGPwIcRLrg-NuZcfNg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5266e034-f333-4f4b-8b20-799c3193ea5f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Blue Valley North High School",
      "poi_type": "Education",
      "poi_address": "12200 Lamar Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-853d-752d-ac1a-e42e903680ff.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-853d-752d-ac1a-e42e903680ff",
        "storage_key": "property/6767906449167620/019fc993-853d-752d-ac1a-e42e903680ff.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.bluevalleyk12.org/bvn",
      "poi_directions_map_url": "https://maps.google.com/?cid=15101532817909822492&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-north-high-school",
      "poi_latitude": "38.9068618",
      "poi_longitude": "-94.6604547",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-239-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJoROKIBLqwIcRHDRrJxZsk9E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_13e9443f-ffcc-4c6c-aa72-fba87f4cc623",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Valley Park Elementary School",
      "poi_type": "Education",
      "poi_address": "12301 Lamar Ave, Overland Park, KS 66209, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/vpe",
      "poi_directions_map_url": "https://maps.google.com/?cid=9356314748604894902&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "valley-park-elementary-school",
      "poi_latitude": "38.9051188",
      "poi_longitude": "-94.6573811",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-239-7600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM_W9fjHqwIcRts5XJbFO2IE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_e98ff55a-30a3-4fd1-97b5-e06988e9752a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Prairie Star Elementary School",
      "poi_type": "Education",
      "poi_address": "3800 W 143rd St, Leawood, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/pse",
      "poi_directions_map_url": "https://maps.google.com/?cid=17327334381607687841&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "prairie-star-elementary-school",
      "poi_latitude": "38.8702107",
      "poi_longitude": "-94.6269646",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 913-239-7100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFYeWxz7CwIcRoZYj4NAOd_A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_b0924d56-d4ff-464a-b7ee-c07e169bbc79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "St. Michael the Archangel Catholic School",
      "poi_type": "Education",
      "poi_address": "14201 Nall Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0100a-fe58-77e5-91bb-005e400d3b90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100a-fe58-77e5-91bb-005e400d3b90",
        "storage_key": "property/6767906449167620/01a0100a-fe58-77e5-91bb-005e400d3b90.webp",
        "width": 1280,
        "height": 646
      },
      "poi_business_url": "https://edu.stmichaelcp.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4651269023836012249&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "st-michael-the-archangel-catholic-school",
      "poi_latitude": "38.8704577",
      "poi_longitude": "-94.6483978",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-402-3950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJta9DNIrBwIcR2f6FoIigjEA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_facb4a71-e7a0-4095-9fd3-3ea00715300b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Hyman Brand Hebrew Academy",
      "poi_type": "Education",
      "poi_address": "5801 W 115th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-4094-7191-8280-f779f0d6806e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-4094-7191-8280-f779f0d6806e",
        "storage_key": "property/6767906449167620/01a0c4ab-4094-7191-8280-f779f0d6806e.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.hbha.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8215028857995554123&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hyman-brand-hebrew-academy",
      "poi_latitude": "38.918381",
      "poi_longitude": "-94.6521267",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-327-8150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJtaeWVyLqwIcRS21opDilAXI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_893ec5b1-c3d7-4f8f-a9eb-fb2efa8ec6eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "University of Kansas Edwards Campus",
      "poi_type": "Education",
      "poi_address": "12600 S Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a3-ba67-74ca-bbda-7661737c6949.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-ba67-74ca-bbda-7661737c6949",
        "storage_key": "property/6767906449167620/019ff6a3-ba67-74ca-bbda-7661737c6949.webp",
        "width": 1280,
        "height": 795
      },
      "poi_business_url": "http://edwardscampus.ku.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15421529977661014929&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "university-of-kansas-edwards-campus",
      "poi_latitude": "38.900081",
      "poi_longitude": "-94.7254776",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-897-8400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcfRKua3qwIcRkcOF085HBNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_bf471924-9810-484b-8017-3157a6160669",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Johnson County Community College",
      "poi_type": "Education",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98d-1462-704e-8d37-90fe4b517117.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-1462-704e-8d37-90fe4b517117",
        "storage_key": "property/6767906449167620/019fc98d-1462-704e-8d37-90fe4b517117.webp",
        "width": 960,
        "height": 540
      },
      "poi_business_url": "https://www.jccc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4939079639992649295&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college",
      "poi_latitude": "38.9237619",
      "poi_longitude": "-94.7303185",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJEejhg2TrwIcRT0Ygo8Mii0Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_709c0cb6-98b9-4a74-b0f0-a851726ef478",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Saint Thomas Aquinas High School",
      "poi_type": "Education",
      "poi_address": "11411 South Pflumm Rd, Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-3e56-72a8-895c-559215fa2dab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-3e56-72a8-895c-559215fa2dab",
        "storage_key": "property/6767906449167620/01a0c4ab-3e56-72a8-895c-559215fa2dab.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.stasaints.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4092999226720322010&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-thomas-aquinas-high-school",
      "poi_latitude": "38.9221637",
      "poi_longitude": "-94.740104",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 913-345-1411",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB3eqtiSVwIcR2gGdbhxBzTg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_cdf0699b-6682-40af-9fa6-6617081e7b88",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Museum at Prairiefire",
      "poi_type": "Entertainment",
      "poi_address": "5801 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_long_description": "Bright, uniquely designed museum with changing natural history exhibits on dinosaurs & space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98d-5874-7284-97bc-bbdacb468ca4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-5874-7284-97bc-bbdacb468ca4",
        "storage_key": "property/6767906449167620/019fc98d-5874-7284-97bc-bbdacb468ca4.webp",
        "width": 1170,
        "height": 797
      },
      "poi_business_url": "https://www.visitthemap.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9011883457387750483&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "museum-at-prairiefire",
      "poi_latitude": "38.8819446",
      "poi_longitude": "-94.6520905",
      "poi_miles_from_property": "0.04",
      "poi_walking_minutes": "1 min",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-333-3500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-947de4fbdd51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-947de4fbdd51",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-947de4fbdd51.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJOdDvHPHBwIcRU-TQ6kGkEH0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_cec30e70-cc98-4501-8a48-ee03a890b62a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "AMC Prairiefire 17",
      "poi_type": "Entertainment",
      "poi_address": "5724 W 136th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Comfortable entertainment venue featuring a full menu alongside movie screenings of new releases.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-df8c-745e-a0e4-bdb1a007cd0b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-df8c-745e-a0e4-bdb1a007cd0b",
        "storage_key": "property/6767906449167620/019fc993-df8c-745e-a0e4-bdb1a007cd0b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amctheatres.com/movie-theatres/kansas-city/amc-prairiefire-17?utm_medium=organic&utm_source=google&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=3727223515720771879&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amc-prairiefire-17",
      "poi_latitude": "38.8826984",
      "poi_longitude": "-94.651566",
      "poi_miles_from_property": "0.1",
      "poi_walking_minutes": "2 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-553-3075",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1daa-754e-a91d-c41467168f31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1daa-754e-a91d-c41467168f31",
        "storage_key": "property/6767906449167620/019ff6a4-1daa-754e-a91d-c41467168f31.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7fXu5_DBwIcRJ-kENQrCuTM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_e6d54d28-616b-4a7f-a801-674da788c422",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "B&B Theatres Overland Park 16",
      "poi_type": "Entertainment",
      "poi_address": "8601 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_long_description": "Relaxed, contemporary multiscreen theater featuring showings of mainstream films.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0100b-2498-77d8-b001-61cdaed1b1ca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0100b-2498-77d8-b001-61cdaed1b1ca",
        "storage_key": "property/6767906449167620/01a0100b-2498-77d8-b001-61cdaed1b1ca.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://www.bbtheatres.com/our-theatres/x0uvh-b-and-b-overland-park-16/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6259761698616561138&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bb-theatres-overland-park-16",
      "poi_latitude": "38.8812512",
      "poi_longitude": "-94.6835183",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-871-5352",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1daa-754e-a91d-c41467168f31.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1daa-754e-a91d-c41467168f31",
        "storage_key": "property/6767906449167620/019ff6a4-1daa-754e-a91d-c41467168f31.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJDWO_qc3BwIcR8s2iaBkk31Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_12d2745b-f6bf-4ed3-a6ec-15a2812999b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Dave & Buster's Overland Park",
      "poi_type": "Restaurants",
      "poi_address": "6811 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-f360-75f9-ac4d-17c5436b02c1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-f360-75f9-ac4d-17c5436b02c1",
        "storage_key": "property/6767906449167620/019fc993-f360-75f9-ac4d-17c5436b02c1.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/overland-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=2445764442989428663&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-overland-park",
      "poi_latitude": "38.88149050000001",
      "poi_longitude": "-94.6652889",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-249-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVr1MujBwIcRt3-qfM0Z8SE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_7e5a517e-afc0-4862-a661-2b62fe73d9d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Pinstripes",
      "poi_type": "Restaurants",
      "poi_address": "13500 Nall Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Italian-American fare, bowling & bocce in a sprawling space with indoor & outdoor seating & a bar.",
      "poi_long_description": "Italian-American fare, bowling & bocce in a sprawling space with indoor & outdoor seating & a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a3-bcc1-742f-9455-0887e4b3ec9d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-bcc1-742f-9455-0887e4b3ec9d",
        "storage_key": "property/6767906449167620/019ff6a3-bcc1-742f-9455-0887e4b3ec9d.webp",
        "width": 839,
        "height": 623
      },
      "poi_business_url": "https://pinstripes.com/?utm_source=local&utm_medium=organic&utm_content=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=5277492073553538943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pinstripes",
      "poi_latitude": "38.8828273",
      "poi_longitude": "-94.6497866",
      "poi_miles_from_property": "0.2",
      "poi_walking_minutes": "4 mins",
      "poi_biking_minutes": "1 min",
      "poi_driving_minutes": "1 min",
      "poi_business_phone": "+1 913-681-2255",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06bf-719f-8822-4ca55dde420b",
        "storage_key": "property/6767906449167620/019fc990-06bf-719f-8822-4ca55dde420b.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUQ-iOPfBwIcRfy8ZXRRrPUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_d520e90b-8ac2-4eae-985b-84b9b8fc1eb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Deanna Rose Children's Farmstead",
      "poi_type": "Entertainment",
      "poi_address": "13800 Switzer Rd, Overland Park, KS 66221, USA",
      "poi_short_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_long_description": "Spacious farmstead featuring replicas of life on the prairie, an ice cream parlor & wagon rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc993-d308-7008-8965-100771fdc86e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc993-d308-7008-8965-100771fdc86e",
        "storage_key": "property/6767906449167620/019fc993-d308-7008-8965-100771fdc86e.webp",
        "width": 640,
        "height": 349
      },
      "poi_business_url": "http://www.opkansas.org/things-to-see-and-do/deanna-rose-childrens-farmstead/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7835830010939554497&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "deanna-rose-childrens-farmstead",
      "poi_latitude": "38.877729",
      "poi_longitude": "-94.703345",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-897-2360",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6IUwjvAwIcRwbplAuF1vmw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_99c66fd9-76d5-485a-8e5e-df881d13aea1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Overland Park Arboretum & Botanical Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8909 W 179th St, Overland Park, KS 66013, USA",
      "poi_short_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_long_description": "Gardens, trails & recreation areas plus educational programs & events on environmental issues.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-2512-74d8-bcca-8af5265aca32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-2512-74d8-bcca-8af5265aca32",
        "storage_key": "property/6767906449167620/019fc994-2512-74d8-bcca-8af5265aca32.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/recreation-fun/arboretum-botanical-gardens/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8713039177416778041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-arboretum--botanical-gardens",
      "poi_latitude": "38.8033925",
      "poi_longitude": "-94.6891159",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-685-3604",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6csjvynHwIcROSH92_fu6ng",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "botanical_garden"
    },
    {
      "id": "custom_0e1959f9-74a2-4842-a3e5-ffa1a7933fbe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Nerman Museum of Contemporary Art",
      "poi_type": "Entertainment",
      "poi_address": "12345 College Blvd, Overland Park, KS 66210, USA",
      "poi_short_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_long_description": "Johnson County Community College's modern-art facility including an auditorium, cafe & classrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98d-397f-70c8-9580-0dc354e00437.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-397f-70c8-9580-0dc354e00437",
        "storage_key": "property/6767906449167620/019fc98d-397f-70c8-9580-0dc354e00437.webp",
        "width": 1080,
        "height": 830
      },
      "poi_business_url": "http://www.nermanmuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4973184191241098516&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nerman-museum-of-contemporary-art",
      "poi_latitude": "38.924852",
      "poi_longitude": "-94.726824",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 30 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 913-469-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-947de4fbdd51.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-947de4fbdd51",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-947de4fbdd51.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVtOx9LqwIcRFJWDQaxMBEU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "art_museum"
    },
    {
      "id": "custom_73a44138-8ffe-489b-96c3-352a6082c9c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Breakout KC Escape Room | Park Place",
      "poi_type": "Entertainment",
      "poi_address": "11535 Ash St, Leawood, KS 66211, USA",
      "poi_short_description": "Escape room chain offering a variety of themed adventures with private rooms for groups.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-4365-779d-b3e8-146e837e1fd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-4365-779d-b3e8-146e837e1fd5",
        "storage_key": "property/6767906449167620/01a0c4ab-4365-779d-b3e8-146e837e1fd5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://breakoutkc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13572545635402228501&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "breakout-kc-escape-room--park-place",
      "poi_latitude": "38.9184004",
      "poi_longitude": "-94.6475129",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-298-1081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJK6eHTSDqwIcRFaPtT1heW7w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_fb489d43-8ab0-4492-bc7a-efbfd78462ed",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Starlight Theatre",
      "poi_type": "Entertainment",
      "poi_address": "4600 Starlight Rd, Kansas City, MO 64132, USA",
      "poi_short_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_long_description": "Iconic outdoor theater in Swope Park hosting Broadway shows, rock concerts & other productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-4017-7346-b75b-b7e60db772ce.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-4017-7346-b75b-b7e60db772ce",
        "storage_key": "property/6767906449167620/01a0c4ab-4017-7346-b75b-b7e60db772ce.webp",
        "width": 1024,
        "height": 683
      },
      "poi_business_url": "https://www.kcstarlight.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12152994064738864795&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "starlight-theatre",
      "poi_latitude": "39.00745440000001",
      "poi_longitude": "-94.5328221",
      "poi_miles_from_property": "14.1",
      "poi_walking_minutes": "5 hours 12 mins",
      "poi_biking_minutes": "1 hour 27 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "+1 816-363-7827",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJg_zL1bnlwIcRm84warYbqKg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_48b3b8bc-dc0d-4031-8d73-021985bcb827",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Saint Luke's South Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "12300 Metcalf Ave, Overland Park, KS 66213, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-295a-7501-9b60-2af00b4f18a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-295a-7501-9b60-2af00b4f18a5",
        "storage_key": "property/6767906449167620/019fc994-295a-7501-9b60-2af00b4f18a5.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.saintlukeskc.org/locations/saint-lukes-south-hospital?utm_source=local-listing&utm_medium=organic&utm_campaign=website-link",
      "poi_directions_map_url": "https://maps.google.com/?cid=8966224544508452770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-lukes-south-hospital",
      "poi_latitude": "38.9041982",
      "poi_longitude": "-94.6695167",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-317-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-9b0ba3534b32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-9b0ba3534b32",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-9b0ba3534b32.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJkT2aF3LqwIcRop_Q17dtbnw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_fcbc1bfc-6dc4-40f8-9e81-5bab585481ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "NextCare Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "4800 W 135th St #190, Leawood, KS 66224, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-4365-779d-b3e8-1a38da22651d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-4365-779d-b3e8-1a38da22651d",
        "storage_key": "property/6767906449167620/01a0c4ab-4365-779d-b3e8-1a38da22651d.webp",
        "width": 1280,
        "height": 950
      },
      "poi_business_url": "https://nextcare.com/locations/ks/ks-urgent-care-leawood-kansas/?utm_source=GoogleMaps&utm_medium=Local&utm_campaign=leawood",
      "poi_directions_map_url": "https://maps.google.com/?cid=3447987672926336901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "nextcare-urgent-care",
      "poi_latitude": "38.8849902",
      "poi_longitude": "-94.6422101",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-428-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJpZ-bzhzCwIcRhTezMoW22S8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_c4a38cf9-344f-4fd3-bb0b-f802f3c0ed57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "CareNow Urgent Care - Corbin Park",
      "poi_type": "Health and Wellness",
      "poi_address": "13761 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-6c2d-753b-9bdb-dcdf5d1c73dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-6c2d-753b-9bdb-dcdf5d1c73dd",
        "storage_key": "property/6767906449167620/019fc994-6c2d-753b-9bdb-dcdf5d1c73dd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.carenow.com/locations/kansas-city/corbin-park?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=17803688775260742105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "carenow-urgent-care---corbin-park",
      "poi_latitude": "38.87859419999999",
      "poi_longitude": "-94.6672924",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-814-3788",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX1b2mqnBwIcR2aEG9ZxoE_c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_10f2f91b-cb1e-4faa-b870-6b989916e091",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Children's Mercy Blue Valley",
      "poi_type": "Health and Wellness",
      "poi_address": "6750 W 135th St, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-394c-765d-a9c6-a06663f6d3a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-394c-765d-a9c6-a06663f6d3a8",
        "storage_key": "property/6767906449167620/019fc994-394c-765d-a9c6-a06663f6d3a8.webp",
        "width": 1280,
        "height": 831
      },
      "poi_business_url": "http://www.childrensmercy.org/urgentcare/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12194765778603454721&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-blue-valley",
      "poi_latitude": "38.8856523",
      "poi_longitude": "-94.6635513",
      "poi_miles_from_property": "1",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-717-4700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJXxWtfTgvd0ARAbG_cN2CPKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_2971269a-817d-4b45-b4e3-214e854a5cb7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11900 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-38a5-701e-ab99-f95f46665759.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-38a5-701e-ab99-f95f46665759",
        "storage_key": "property/6767906449167620/019fc994-38a5-701e-ab99-f95f46665759.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/overland-park-ks-pharmacies/11900-w-135th-street-overland-park-ks-66221/storeid=8573?WT.mc_id=LS_GOOGLE_RX_8573",
      "poi_directions_map_url": "https://maps.google.com/?cid=16737888902109505670&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "38.88672529999999",
      "poi_longitude": "-94.7244414",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 51 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-814-7003",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1ce7-746b-9169-2100f7d883fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1ce7-746b-9169-2100f7d883fa",
        "storage_key": "property/6767906449167620/019ff6a4-1ce7-746b-9169-2100f7d883fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2YMozgbAwIcRhqgwfEbtSOg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_8fd37b32-e224-4bdc-82a9-32501396860c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "8681 W 135th St Walgreens, Overland Park, KS 66223, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a3-d3e1-723a-9247-acb9c12e5da2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-d3e1-723a-9247-acb9c12e5da2",
        "storage_key": "property/6767906449167620/019ff6a3-d3e1-723a-9247-acb9c12e5da2.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-8681+w+135th+st-overland+park-ks-66223/id=6920",
      "poi_directions_map_url": "https://maps.google.com/?cid=14836544926270681840&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "38.8805102",
      "poi_longitude": "-94.6859559",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 913-239-9168",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcywI18zBwIcR8PJ8yAD_5c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_f9680509-8d27-423f-9247-19d48354f998",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Hy-Vee Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "8900 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-4ff9-763b-a1ad-88738e7ece3e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-4ff9-763b-a1ad-88738e7ece3e",
        "storage_key": "property/6767906449167620/019fc994-4ff9-763b-a1ad-88738e7ece3e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.hy-vee.com/my-pharmacy/pharmacy-finder/overland-park-2-8900-w-135-st-overland-park-ks/1509?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10592957387033179426&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hy-vee-pharmacy",
      "poi_latitude": "38.8853994",
      "poi_longitude": "-94.6884219",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-685-3299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1ce7-746b-9169-2100f7d883fa.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1ce7-746b-9169-2100f7d883fa",
        "storage_key": "property/6767906449167620/019ff6a4-1ce7-746b-9169-2100f7d883fa.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ____BC3AwIcRInX2np6-AZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_81482198-9d7d-4fb0-91b7-f7f0882b4280",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "6800 138th St, Overland Park, KS 66223, USA",
      "poi_short_description": "Upscale gym with a spa, an indoor and an outdoor pool, plus a hair salon.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98d-5cc9-756b-9a10-5076756b6179.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-5cc9-756b-9a10-5076756b6179",
        "storage_key": "property/6767906449167620/019fc98d-5cc9-756b-9a10-5076756b6179.webp",
        "width": 1200,
        "height": 627
      },
      "poi_business_url": "https://www.lifetime.life/locations/ks/overland-park?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=6007822183813280658&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "38.8789466",
      "poi_longitude": "-94.6645722",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 913-239-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeyRfIerBwIcRkvPmA3ISYFM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_d1aa8e0e-5dfa-4840-bfb9-569bd83e2f94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "11320 W 135th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Chain gym with tanning and spa facilities, as well as hydroloungers.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98d-9d1c-76a9-9505-e7b105e7f86f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-9d1c-76a9-9505-e7b105e7f86f",
        "storage_key": "property/6767906449167620/019fc98d-9d1c-76a9-9505-e7b105e7f86f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/overland-park-135th-st-ks?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=1396585211980257129&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "38.88575820000001",
      "poi_longitude": "-94.71868700000002",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 40 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-402-0999",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu_puNwXAwIcRaZel0tmqYRM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0ac47c6b-14b2-4728-b6cc-d4525639cd27",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Orangetheory Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "13621 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Heart rate–based, calorie-burning studio featuring group classes and workouts that can be tracked in real-time.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-7191-74b8-8629-d9f696e9c823.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-7191-74b8-8629-d9f696e9c823",
        "storage_key": "property/6767906449167620/019fc994-7191-74b8-8629-d9f696e9c823.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.orangetheory.com/en-us/locations/kansas/overland-park/13621-metcalf-ave/?utm_medium=seo&utm_source=gg&utm_term=tombras&utm_campaign=reputationdotcom--National",
      "poi_directions_map_url": "https://maps.google.com/?cid=2517780848240473361&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "orangetheory-fitness",
      "poi_latitude": "38.8814048",
      "poi_longitude": "-94.6672773",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 913-213-1012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJz2AK5sLBwIcREbWneVf08CI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_bd481c5d-047f-48e4-a2dd-bda9e9e3f6a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Blue Valley Recreation Sports Complex",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9701 W 137th St, Overland Park, KS 66221, USA",
      "poi_short_description": "Outdoor venue with 24 fields hosting softball games and tournaments.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a3-db4d-70d1-8bc0-c5a5f3b8f054.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-db4d-70d1-8bc0-c5a5f3b8f054",
        "storage_key": "property/6767906449167620/019ff6a3-db4d-70d1-8bc0-c5a5f3b8f054.webp",
        "width": 1280,
        "height": 688
      },
      "poi_business_url": "http://www.bluevalleyrec.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5975901045562969972&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-recreation-sports-complex",
      "poi_latitude": "38.8786991",
      "poi_longitude": "-94.694739",
      "poi_miles_from_property": "3.1",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 913-685-6030",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk7nfBzHAwIcRdI-q2Vaq7lI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_complex"
    },
    {
      "id": "custom_fff3a000-073b-4883-a3f0-0c0d4f6054ab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Quivira Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11901 Quivira Rd, Overland Park, KS 66213, USA",
      "poi_short_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_long_description": "Small community park featuring a playground, picnic tables & 2 sand volleyball courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a3-e6b5-7428-8ec6-b6161f138e65.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-e6b5-7428-8ec6-b6161f138e65",
        "storage_key": "property/6767906449167620/019ff6a3-e6b5-7428-8ec6-b6161f138e65.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17176832562132200599&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quivira-park",
      "poi_latitude": "38.9107813",
      "poi_longitude": "-94.7229342",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-36f46af419af",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmbS_K7TqwIcRl6xAYDVeYO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_3a9d5a71-3db7-47e3-9ae6-b94985a0f43e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Thomas S. Stoll Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 119th St, Overland Park, KS 66210, USA",
      "poi_short_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_long_description": "Public 79-acre park with 7 ball fields, a fishing lake, a playground & a scenic nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-4b35-75cc-a4c4-b0efe3b996c3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-4b35-75cc-a4c4-b0efe3b996c3",
        "storage_key": "property/6767906449167620/01a0c4ab-4b35-75cc-a4c4-b0efe3b996c3.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jcprd.com/parks_facilities/stoll_park.cfm",
      "poi_directions_map_url": "https://maps.google.com/?cid=11904290777782419563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "thomas-s-stoll-memorial-park",
      "poi_latitude": "38.9133269",
      "poi_longitude": "-94.7313061",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 17 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 913-438-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-36f46af419af",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ06uvXjSVwIcRawCuCGSJNKU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d24ec92f-a748-4671-a832-25b1c5666bb6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Corporate Woods Founders Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9300 Indian Creek Pkwy, Overland Park, KS 66210, USA",
      "poi_short_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_long_description": "Recreational park featuring forested trails, a splash fountain & an open field for picnics & events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-48cf-730d-81cf-31f6918a9180.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-48cf-730d-81cf-31f6918a9180",
        "storage_key": "property/6767906449167620/01a0c4ab-48cf-730d-81cf-31f6918a9180.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.opkansas.org/park/corporate-woods-founders-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14583573077730300202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "corporate-woods-founders-park",
      "poi_latitude": "38.933341",
      "poi_longitude": "-94.6949701",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-36f46af419af",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ05niK_3qwIcRKpEQdnJCY8o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_1af6cc46-714e-412c-9530-22ac5ea5dd3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Regency Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "14800 Lamar Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "Playground, swings and slides at this chill park featuring a lake and walking paths.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a3-dfa6-715f-a767-46f991fc45ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019ff6a3-dfa6-715f-a767-46f991fc45ed",
        "storage_key": "property/6767906449167620/019ff6a3-dfa6-715f-a767-46f991fc45ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15463142209822193210&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regency-lake-park",
      "poi_latitude": "38.8596074",
      "poi_longitude": "-94.6614219",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-36f46af419af",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJZQkARJnBwIcROvbMn-kdmNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_64dc4c34-f525-430b-a91d-31f279b9114a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Amesbury Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "12500 W 143rd St, Overland Park, KS 66221, USA",
      "poi_short_description": "Compact park for the local community offering a playground & a picnic pavilion.",
      "poi_long_description": "Compact park for the local community offering a playground & a picnic pavilion.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-a5a2-76a3-9b18-b07331807ebd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-a5a2-76a3-9b18-b07331807ebd",
        "storage_key": "property/6767906449167620/019fc994-a5a2-76a3-9b18-b07331807ebd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://opkansas.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4440362089559726751&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "amesbury-lake-park",
      "poi_latitude": "38.87158",
      "poi_longitude": "-94.7344131",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 913-895-6390",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-36f46af419af",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP32izPK_wIcRn5pRXstVnz0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_217d1405-b218-4764-9f12-cc16bd592851",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Olathe Two Trails Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1000 N Ridgeview Rd, Olathe, KS 66061, USA",
      "poi_short_description": "Locally popular outdoor spot featuring a baseball field, tennis courts and a playground.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-4acb-74d1-a01a-22738a972358.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-4acb-74d1-a01a-22738a972358",
        "storage_key": "property/6767906449167620/01a0c4ab-4acb-74d1-a01a-22738a972358.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.olatheks.gov/government/parks-recreation/parks-trails-bike-lanes/two-trails-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=8981433256265339244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olathe-two-trails-park",
      "poi_latitude": "38.8952567",
      "poi_longitude": "-94.7958439",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 913-971-8563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-36f46af419af",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJz3TyQPGVwIcRbFGT_fV1pHw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_68a06b71-ccbd-4cf5-a9d4-154e4b090e16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Oak Park Mall Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66214, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16122160475460681538&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "oak-park-mall-park--ride",
      "poi_latitude": "38.9552209",
      "poi_longitude": "-94.7216049",
      "poi_miles_from_property": "8.4",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1da4-7601-8ba5-34831c05cf77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1da4-7601-8ba5-34831c05cf77",
        "storage_key": "property/6767906449167620/019ff6a4-1da4-7601-8ba5-34831c05cf77.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVwpg4UnrwIcRQj-tl4hrvd8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_d73b9496-3f33-4868-9769-6557aec47f5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Johnson County Community College Midwest Trust Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Overland Park, KS 66210, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=4960772401325825833&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-community-college-midwest-trust-center",
      "poi_latitude": "38.925719",
      "poi_longitude": "-94.727834",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 34 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1dbe-7526-b254-19ac2eb535fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1dbe-7526-b254-19ac2eb535fc",
        "storage_key": "property/6767906449167620/019ff6a4-1dbe-7526-b254-19ac2eb535fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5fi-LC2VwIcRKV-WODc02EQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_0c2d93fa-1e2e-47c6-abb7-9f8d63af29ee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Lenexa City Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "Lenexa, KS 66219, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-49fb-7478-b28b-7dff847cc2e6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-49fb-7478-b28b-7dff847cc2e6",
        "storage_key": "property/6767906449167620/01a0c4ab-49fb-7478-b28b-7dff847cc2e6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=1343754772439581652&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lenexa-city-center",
      "poi_latitude": "38.9705795",
      "poi_longitude": "-94.7818111",
      "poi_miles_from_property": "12.4",
      "poi_walking_minutes": "4 hours 38 mins",
      "poi_biking_minutes": "1 hour 12 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1dbe-7526-b254-19ac2eb535fc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1dbe-7526-b254-19ac2eb535fc",
        "storage_key": "property/6767906449167620/019ff6a4-1dbe-7526-b254-19ac2eb535fc.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJwSf48XaUwIcR1EN_lNj5pRI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bus_stop"
    },
    {
      "id": "custom_07b948d0-b04e-4abc-92ae-ef62ade5d5c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Mission Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5251 Johnson Dr, Roeland Park, KS 66205, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ridekc.org/locations/mission_transit_center",
      "poi_directions_map_url": "https://maps.google.com/?cid=14750820283784844061&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-transit-center",
      "poi_latitude": "39.0229186",
      "poi_longitude": "-94.6460432",
      "poi_miles_from_property": "10.2",
      "poi_walking_minutes": "3 hours 47 mins",
      "poi_biking_minutes": "1 hour 2 mins",
      "poi_driving_minutes": "22 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019ff6a4-1da4-7601-8ba5-34831c05cf77.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019ff6a4-1da4-7601-8ba5-34831c05cf77",
        "storage_key": "property/6767906449167620/019ff6a4-1da4-7601-8ba5-34831c05cf77.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0RGVf9XtwIcRHVOfGOVwtcw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "parking_lot"
    },
    {
      "id": "custom_8729f7b3-2410-4852-9593-b638022829a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Kansas City International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "1 Kansas City Blvd, Kansas City, MO 64153, USA",
      "poi_short_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_long_description": "Airport featuring domestic & global flights plus free WiFi & a variety of eateries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-c1a0-7634-b510-6cba03dc01f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-c1a0-7634-b510-6cba03dc01f0",
        "storage_key": "property/6767906449167620/019fc994-c1a0-7634-b510-6cba03dc01f0.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.flykc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14109162014977743520&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kansas-city-international-airport",
      "poi_latitude": "39.3013901",
      "poi_longitude": "-94.7104232",
      "poi_miles_from_property": "38.3",
      "poi_walking_minutes": "14 hours 16 mins",
      "poi_biking_minutes": "4 hours 10 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 816-243-5237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c3-7659-81fa-8fb7f24231bf.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c3-7659-81fa-8fb7f24231bf",
        "storage_key": "property/6767906449167620/019fc990-06c3-7659-81fa-8fb7f24231bf.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJmYfmiAhewIcRoNouXRnQzcM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_2cccbee6-b3ef-48e1-81c9-7897e98470d0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "T-Mobile Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6220 Sprint Pkwy, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98e-d21d-71d3-88dc-5f89ac0192a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98e-d21d-71d3-88dc-5f89ac0192a0",
        "storage_key": "property/6767906449167620/019fc98e-d21d-71d3-88dc-5f89ac0192a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16065491002476993060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "t-mobile-corporate-office",
      "poi_latitude": "38.9149922",
      "poi_longitude": "-94.6573794",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 855-977-5086",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJI0P_xjzrwIcRJBrguPIW9N4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_cefdf022-aa21-4d56-b308-4cc1395c8714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Garmin",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1200 E 151st St, Olathe, KS 66062, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-f1ad-737d-96ea-fe9db03c576b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-f1ad-737d-96ea-fe9db03c576b",
        "storage_key": "property/6767906449167620/019fc994-f1ad-737d-96ea-fe9db03c576b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.garmin.com/en-US",
      "poi_directions_map_url": "https://maps.google.com/?cid=7856958804647333168&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "garmin",
      "poi_latitude": "38.8553721",
      "poi_longitude": "-94.7996464",
      "poi_miles_from_property": "9.1",
      "poi_walking_minutes": "3 hours 23 mins",
      "poi_biking_minutes": "1 hour 0 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-800-1020",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdY73mS-wIcRMM3hpWeGCW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_e5443204-7474-40e6-be40-b2fb6f0ce7ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Black & Veatch",
      "poi_type": "Major Employers & Offices",
      "poi_address": "11401 Lamar Ave, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-c26e-7209-b5c7-58a15fa13585.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-c26e-7209-b5c7-58a15fa13585",
        "storage_key": "property/6767906449167620/019fc994-c26e-7209-b5c7-58a15fa13585.webp",
        "width": 1280,
        "height": 653
      },
      "poi_business_url": "http://www.bv.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15245877116558125981&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "black--veatch",
      "poi_latitude": "38.9250015",
      "poi_longitude": "-94.6553624",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 913-458-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-33d31e003779",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-33d31e003779.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUyTe2TrqwIcRnSu0HXY8lNM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "consultant"
    },
    {
      "id": "custom_e821a6b5-51ce-44cd-8f4f-968b1320128c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Blue Valley School District Office #229",
      "poi_type": "Major Employers & Offices",
      "poi_address": "15020 Metcalf Ave, Overland Park, KS 66223, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.bluevalleyk12.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12406361877646761667&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "blue-valley-school-district-office-229",
      "poi_latitude": "38.8566433",
      "poi_longitude": "-94.6685552",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 913-239-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-92d1ab5a7d9d",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-92d1ab5a7d9d.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJkUYMDKHBwIcRw14VYGVALKw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a27d8bc6-3603-475a-9950-209a2ed029a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Children's Mercy Kansas",
      "poi_type": "Health and Wellness",
      "poi_address": "5808 W 110th St, Overland Park, KS 66211, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc98d-e5ef-75ef-b41c-f4cf16ef8afe.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc98d-e5ef-75ef-b41c-f4cf16ef8afe",
        "storage_key": "property/6767906449167620/019fc98d-e5ef-75ef-b41c-f4cf16ef8afe.webp",
        "width": 720,
        "height": 1280
      },
      "poi_business_url": "https://www.childrensmercy.org/Kansas/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8535209985424805612&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-mercy-kansas",
      "poi_latitude": "38.9299718",
      "poi_longitude": "-94.6522904",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 913-696-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-9b0ba3534b32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-9b0ba3534b32",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-9b0ba3534b32.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ03Xo8C7qwIcR7M6coEIoc3Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_704e6ab9-bfd9-4828-a773-90bcedb83015",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Overland Park Regional Medical Center",
      "poi_type": "Health and Wellness",
      "poi_address": "10500 Quivira Rd, Overland Park, KS 66215, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-c6db-7529-bc87-178263ea3cac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-c6db-7529-bc87-178263ea3cac",
        "storage_key": "property/6767906449167620/019fc994-c6db-7529-bc87-178263ea3cac.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.hcamidwest.com/locations/overland-park-regional-medical-center?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=13555409796355494155&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-regional-medical-center",
      "poi_latitude": "38.9376197",
      "poi_longitude": "-94.7261812",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 913-541-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c0-75fc-85bc-9b0ba3534b32.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c0-75fc-85bc-9b0ba3534b32",
        "storage_key": "property/6767906449167620/019fc990-06c0-75fc-85bc-9b0ba3534b32.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4cFCWJzAwIcRC5Ge4GN9Hrw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_3cc9504f-3609-44db-b138-f627b9476642",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Overland Park City Hall",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "8500 Santa Fe Dr, Overland Park, KS 66212, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc994-dfb9-75dc-bce9-16b6625ecbac.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fc994-dfb9-75dc-bce9-16b6625ecbac",
        "storage_key": "property/6767906449167620/019fc994-dfb9-75dc-bce9-16b6625ecbac.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.opkansas.org/park/city-hall-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10640252352095117489&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "overland-park-city-hall",
      "poi_latitude": "38.97448380000001",
      "poi_longitude": "-94.6854831",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "3 hours 0 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 913-895-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fc990-06c1-7585-a565-36f46af419af",
        "storage_key": "property/6767906449167620/019fc990-06c1-7585-a565-36f46af419af.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJmdh8t4HrwIcRseAkxyPFqZM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d5b5ddc5-1e7d-4e8c-919f-be9222d1d05a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "custom",
      "poi_name": "Johnson County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "111 S Cherry St, Olathe, KS 66061, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-4e37-756f-b663-471ced22d596.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-4e37-756f-b663-471ced22d596",
        "storage_key": "property/6767906449167620/01a0c4ab-4e37-756f-b663-471ced22d596.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jocogov.org/contact-us/all-locations/administration-building",
      "poi_directions_map_url": "https://maps.google.com/?cid=15575052816225759890&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-county-administration-building",
      "poi_latitude": "38.8815028",
      "poi_longitude": "-94.8200342",
      "poi_miles_from_property": "10.3",
      "poi_walking_minutes": "3 hours 49 mins",
      "poi_biking_minutes": "59 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 913-715-7400",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4ab-55e9-75bd-8159-65aec78dde95.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "01a0c4ab-55e9-75bd-8159-65aec78dde95",
        "storage_key": "property/6767906449167620/01a0c4ab-55e9-75bd-8159-65aec78dde95.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJc9_Fbvq9wIcRknIVJQS0Jdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "local_government_office"
    }
  ],
  "office_hours": [
    {
      "id": "ec_a7ffa6e25658030b8b3f4057",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "day": "MON",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_2f9e5b860f31c26abf27439e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "day": "TUE",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_835805bb29a43042c47d44fc",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "day": "WED",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_ec00f68772af0a910d2ef89a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "day": "THU",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_72e19f4a998fce3a213f9f76",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "day": "FRI",
      "open_time": "09:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_0e5f22d8d459d54a6e9fec81",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_feff2880c6d8f10aee49e0fe",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "rating": "5",
      "name": "Sydney Fields",
      "text": "I wanted to wait until we had lived here for a while before writing a review. When my husband and I moved here with our son, we originally chose this apartment mainly because we loved the area. What we didn’t realize at the time was just how much we would end up loving and truly feeling at home here.\n\nMy husband and I are both military, so we’ve lived in many different places and apartments over the years. I can honestly say this has been our favorite, and it continues to exceed our expectations the longer we live here.\n\nWhen we first moved in around September 2025, the apartment was exceptionally clean and completely ready for us. We did have a few issues at first with the air conditioning, refrigerator, and a couple of other things since the building had recently been reopened after being closed for a few months for repairs. However, within a day of submitting our maintenance requests, maintenance stopped by to discuss the concerns, fixed what they could immediately, and then returned within the week to completely fix our air conditioning. They even stayed late to finish the job, despite me offering for them to come back the next day so they could go home.\n\nSince then, maintenance has always responded quickly and worked hard to fix any issues in a timely manner, which is something many apartment complexes unfortunately don’t do. The staff in the leasing office and the maintenance team have always been friendly, helpful, and easy to work with.\n\nThere are also so many great amenities that we really enjoy. The gym is perfect for getting in a workout, there are two pools, grilling areas, and even a quiet workspace in the leasing office with computers available if needed.\n\nThe location is also amazing. There are plenty of places within walking distance, and it’s right next to PrairieFire. Overall, we would absolutely recommend this community to anyone. It truly offers so much more than just an apartment,  it feels like home.\n\nBelow are photos of when we first moved in.",
      "date": "2026-03-16",
      "title": "false"
    },
    {
      "id": "ec_ae4b6c09dcc1b768f9c36c40",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "rating": "5",
      "name": "Andrew Jelinek",
      "text": "I recently moved into the Residences at Prairiefire, and even though my moving day was a complete nightmare with delays and even a tire flying off my trailer, the staff here completely turned things around the moment I arrived. Jennifer, Tara, and Sara greeted me with warm smiles, offered me a drink, and even gave my mini Australian Shepherd some treats. After the day I’d had, that small kindness made a huge difference. They made the move‑in process quick and easy so I could finally get inside and relax, and they were patient with every question I had.\n\nThere were a couple of issues in the apartment when I moved in, and I want to call out the maintenance staff just as much as the front office team. They came by the very next business day, were incredibly friendly, and fixed everything quickly and thoroughly. It was clear they take pride in their work and genuinely care about residents having a good experience.\n\nThe location is fantastic, with plenty of restaurants and activities nearby and easy access to the main roads in Overland Park. The new management team has also been putting a lot of effort into renovations and improvements, and it really shows.\n\nOverall, the staff and the community have been outstanding. After such a stressful move, their kindness, professionalism, and quick support made all the difference. I would highly recommend this place to anyone considering it.",
      "date": "2026-05-04",
      "title": "false"
    },
    {
      "id": "ec_53dba5a6d0a4e19e6d9a5622",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "rating": "5",
      "name": "Lori Hirons",
      "text": "We were in town for a wedding and used the guest apartment.  I can’t rave enough.  Very well appointed. Clean, bright and really comfortable.  Besides all of that the management is top flight.  I only had a couple of interactions with them but they were friendly and extremely helpful! Highly recommend.",
      "date": "2026-08-11",
      "title": "false"
    },
    {
      "id": "ec_5ba56128b73e171988f0a6de",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "rating": "5",
      "name": "LivingWith TheBest",
      "text": "I had a really positive experience with this apartment community. From the beginning, the communication was clear, timely, and welcoming. Tara, in particular, stood out—she was incredibly helpful and consistent with her follow-up emails and phone calls, always making sure my questions were answered and that I had everything I needed to make an informed decision.\n\nEven though I ultimately decided not to move forward with this location, the professionalism and care shown throughout the process made a lasting impression. It’s clear that they value potential residents and take pride in providing a smooth and respectful experience.\n\nI would absolutely recommend reaching out to them if you’re considering this community.",
      "date": "2026-04-22",
      "title": "false"
    },
    {
      "id": "ec_b41cfec2883adad081235b7c",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "rating": "5",
      "name": "Will",
      "text": "Ever since Price Brothers purchased this complex they have taken great care of it. Fixed up the hallways, painted, new carpet, repaved the parking lot. It’s a great location and a good apartment for the price.",
      "date": "2026-07-25",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "ec_7fe361a3177db884a511074c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-8a29-71a8-8cfc-eec372de77aa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0c4aa-8a29-71a8-8cfc-eec372de77aa",
        "storage_key": "property/6767906449167620/01a0c4aa-8a29-71a8-8cfc-eec372de77aa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A1 - GETTY",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=gCUsNs2LzUD"
    },
    {
      "id": "ec_7b817d70a04a5aa813da4e1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-8ef3-758b-a229-dedeba0a7aec.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0c4aa-8ef3-758b-a229-dedeba0a7aec",
        "storage_key": "property/6767906449167620/01a0c4aa-8ef3-758b-a229-dedeba0a7aec.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "A2 - GUGGENHEIM",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=YzQXJfLuhMj"
    },
    {
      "id": "ec_df45c1fe74865d95531cfcf4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Experience elevated living in The Met, a spacious 2‑bed, 2‑bath apartment at Residences at Prairiefire featuring an open kitchen, private deck, walk‑in closets, and modern conveniences in the heart of Overland Park’s vibrant Prairiefire district.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-822c-7740-b176-de47fb5f0daa.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0c4aa-822c-7740-b176-de47fb5f0daa",
        "storage_key": "property/6767906449167620/01a0c4aa-822c-7740-b176-de47fb5f0daa.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B1 - MET",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=4nq64qfqMZR"
    },
    {
      "id": "ec_bd0f3659770568e4b225cc1a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-806f-75be-8da0-f51f7bbbafd4.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0c4aa-806f-75be-8da0-f51f7bbbafd4",
        "storage_key": "property/6767906449167620/01a0c4aa-806f-75be-8da0-f51f7bbbafd4.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B2 - POMPIDOU",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Jr5Hjuu9k84"
    },
    {
      "id": "ec_abb748736f9f888f80fa6774",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "yardi",
      "url_health_error": "false",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167620/01a0c4aa-8961-707b-9873-b4740b846fe2.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0c4aa-8961-707b-9873-b4740b846fe2",
        "storage_key": "property/6767906449167620/01a0c4aa-8961-707b-9873-b4740b846fe2.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "B3 - MOMA",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=vtqQ51xp7pM"
    }
  ],
  "faqs": [
    {
      "id": "custom_e2423b15-a8a1-4bb1-99db-847637510260",
      "question": "What are the qualifications for occupancy?",
      "answer": "Check our occupancy qualifications <a href=\"https://www.pricebrotherskc.com/ResidentialRentalQualifications/\">here</a>. We encourage everyone to apply, and hope to have you as a part of our community!",
      "category": "Rental Qualifications",
      "source": "custom"
    },
    {
      "id": "custom_e0c47d64-df9b-4147-b38d-f2f1222c9b51",
      "question": "What is the application fee and is it refundable?",
      "answer": "Application fees are due for each person 18 and older occupying the apartment. All application fees are nonrefundable.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_2dcfd4a1-df9c-47ef-9bb8-18b49868ac52",
      "question": "How do I apply?",
      "answer": "Click on the <a href=\"/apply-now\">Apply Now</a> button under the <a href=\"/floor-plans\">Floor Plans</a> tab of our community website.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_33196624-6b67-4b2d-89f3-098e09cddbbe",
      "question": "What is a holding deposit or earnest money?",
      "answer": "A \"holding\" deposit or \"earnest money\" is another word for \"security\" deposit. Please <a href=\"/contact-us\">contact our leasing office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3be8def5-4433-47b4-8e1e-4577a1196868",
      "question": "Are there different lease term options available?",
      "answer": "Yes, we offer various lease term options. Please <a href=\"/contact-us\">contact our office</a> for more details.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_96653827-beb1-4307-a669-4d109cd31a11",
      "question": "Do I need an appointment to take a tour?",
      "answer": "No appointment is necessary to tour our community during business hours; however, it is always appreciated if you call ahead to make sure we are available to provide adequate time for you to tour and ask questions. It is recommended to arrive no later than one half hour prior to closing if you would like to tour the community. Everyone over 18 years of age must have a valid photo ID to tour. Valid forms of identification are decided by Price Brothers Management Company and may include items such as: US Driver’s License, US State Photo ID, US Military Photo ID, US Visa with Photo ID upon it, US Citizenship and Immigration Services Photo ID, Passport.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_9734fdbb-23f8-4f43-b65f-b236261bfef1",
      "question": "Do you allow pets?",
      "answer": "Our community is happy to accept cats and dogs. Please refer to our pet section on the <a href=\"/pet-policy\">Pet Policy</a> page.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ce82f598-8e49-4b38-895f-025028f138c4",
      "question": "What utilities am I responsible to pay?",
      "answer": "Our residents are responsible to pay for water, trash, pest control and electric.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_dd9adfe4-7afc-4d42-b0f7-456a44be64fe",
      "question": "Why does your pricing include ranges?",
      "answer": "The prices will range on each floor plan depending on finishes, views, and other features inside the apartment home.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_e60ea15b-b4e0-4c4a-ace6-97140f9c0583",
      "question": "Do you require renters insurance?",
      "answer": "All residents are required to maintain a minimum of $100,000 in liability coverage as part of their lease agreement. For more details on coverage requirements and available options, please <a href=\"/contact-us\">contact our leasing office</a>.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_3328e2e0-b4e2-4409-bf8e-1961d0cff411",
      "question": "How can I refer a friend?",
      "answer": "If you love living here and want to refer a friend, please let our office know! We offer resident referral programs throughout the year and would love for your friends and family to join our community.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_73b7c71a-55e6-4bae-9507-9731d36cac5b",
      "question": "How can I pay my rent?",
      "answer": "You can pay rent by accessing your <a href=\"/resident-access\">resident online account</a>. This allows you to use a bank account or credit card to make payments.",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_ec126f20-8979-46c7-a24a-b0c0aa6d028f",
      "question": "Do you offer flexible rent payment options?",
      "answer": "Yes! We’ve partnered with Flex to make paying rent easier for our residents. Flex allows you to split your rent into smaller, more manageable payments throughout the month, giving you added financial flexibility. For more details or to sign up, <a href=\"/contact-us\">contact our leasing office</a> today!",
      "category": "Admin",
      "source": "custom"
    },
    {
      "id": "custom_da5c30a4-a048-40a1-9635-d084044815a3",
      "question": "Do you offer covered parking?",
      "answer": "Yes, we offer attached and detached garages. Please <a href=\"/contact-us\">contact the office</a> for our most current garage availability and pricing.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_c27fd77e-6f1f-4440-a4fe-3a22d16b1715",
      "question": "Do you host events at your property?",
      "answer": "Yes, we host events throughout the year with various activities to encourage community camaraderie.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_96b2aab4-d7b0-4a65-8bb0-ac6754e6e694",
      "question": "Do you accept packages on behalf of the residents?",
      "answer": "The Residences at Prairiefire has package lockers for our residents.",
      "category": "Amenities",
      "source": "custom"
    },
    {
      "id": "custom_956d0df8-5486-4533-aa2b-6742eee51914",
      "question": "If something needs to be repaired in my apartment, how do I report it?",
      "answer": "You may call the office or submit work orders online by accessing your <a href=\"/resident-access\">resident account</a>. All emergency repairs should be reported by <a href=\"/contact-us\">contacting the office</a>. If the emergency is being reported after business hours, please follow the prompts to be connected to the answering service.",
      "category": "Maintenance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0c9ac-3f56-7532-a7b7-3558a73192f6",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Residences at Prairiefire Apartment Homes Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620"
    },
    {
      "lead_collector_id": "01a0c9ac-3fd9-7608-b5f7-645c9d39ed2e",
      "lead_source": "LANDING_PAGE",
      "name": "Residences at Prairiefire Apartment Homes Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "in-unit-laundry-apartments-overland-park",
      "search_query": "apartments with in-unit laundry Overland Park",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Explore Overland Park living with in-unit laundry. Convenience meets style at Residences at Prairiefire Apartment Homes.",
      "page_copy": "Discover the convenience of apartments with in-unit laundry at Residences at Prairiefire Apartment Homes. Situated in the vibrant neighborhood of Prairiefire in Overland Park, KS, our community offers a perfect blend of style and function. Spacious one-, two-, and three-bedroom layouts provide modern elegance with the added benefit of in-unit laundry facilities, ensuring your home life is always seamless.\n\nLocated just moments away from premier dining, shopping, and entertainment options, you'll relish the polished lifestyle in a community that prides itself on luxurious living. Modern finishes, resort-style amenities, and controlled access ensure comfort and security for all residents. Enjoy the ease of quick highway connections and the beauty of a home with a pool view or balcony. Experience a new level of convenience and style in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Overland Park",
      "seo_description": "Discover Overland Park's Residences at Prairiefire with in-unit laundry. Conveniences include quick highway access, dining, and shopping nearby.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-pool-johnson-county",
      "search_query": "luxury apartments with pool in Johnson County",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Pool Amenities",
      "h2_subtitle": "Experience true luxury with pool amenities in Johnson County. Enjoy elegant living at Residences at Prairiefire Apartment Homes.",
      "page_copy": "Discover the epitome of luxury living at Residences at Prairiefire Apartment Homes, located in the heart of Johnson County. Our upscale community offers spacious one-, two-, and three-bedroom layouts, complete with premium finishes and resort-style amenities. Highlighted by a refreshing pool, our facilities provide the perfect way to unwind and socialize.\n\nNestled effortlessly between elegant shopping, dining, and entertainment options, your new home places you at the center of Overland Park life. Enjoy features like controlled access, crown molding, and select apartments with pool views or balconies. With swift highway connections and the scenic energy of Prairiefire, experience both convenience and style in one luxurious package. Make your move to Johnson County's finest living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Pool in Johnson County",
      "seo_description": "Live luxuriously at Residences at Prairiefire in Johnson County. Enjoy premium finishes, a pool, and accessibility to dining and shopping.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-near-prairiefire",
      "search_query": "air conditioned apartments near Prairiefire",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments near Prairiefire",
      "h2_subtitle": "Stay cool in air conditioned apartments close to Prairiefire. Discover comfort at Residences at Prairiefire Apartment Homes.",
      "page_copy": "Embrace the ultimate comfort with air conditioned apartments at Residences at Prairiefire Apartment Homes, ideally located near the vibrant Prairiefire neighborhood in Overland Park. Our thoughtfully designed one-, two-, and three-bedroom floor plans ensure you enjoy a refreshingly cool environment throughout, no matter the season. \n\nSituated amidst top-tier dining, shopping, and entertainment, our homes provide an unparalleled living experience with modern amenities right at your doorstep. Relish luxurious features such as controlled access, crown molding, and options like a balcony or pool view. With quick access to highways, exploring Johnson County and beyond is effortless. Elevate your lifestyle in an air conditioned haven within reach of all that Overland Park has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments near Prairiefire",
      "seo_description": "Find comfort at Residences at Prairiefire with air conditioned living. Close to dining and highways in the vibrant Prairiefire area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-overland-park-ks",
      "search_query": "pet-friendly apartments in Overland Park KS",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in Overland Park",
      "h2_subtitle": "Welcoming pets in Overland Park, KS. Enjoy a pet-friendly lifestyle at Residences at Prairiefire Apartment Homes.",
      "page_copy": "At Residences at Prairiefire Apartment Homes, pets are part of our community! Our pet-friendly apartments in Overland Park, KS are designed to accommodate your furry companions alongside stylish living. Choose from spacious one-, two-, and three-bedroom floor plans, providing ample room for you and your pets to roam comfortably.\n\nLocated in the charming neighborhood of Prairiefire, you'll find yourself amidst a vibrant scene of dining, shopping, and outdoor activities, perfect for both you and your pet to enjoy. Our luxury amenities include crown molding, controlled access, and select options with a pool view or balcony. With quick highway access, exploring the beauty of Overland Park and the wider Johnson County area is a breeze. Delight in a harmonious living experience where pets are warmly welcomed.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in Overland Park, KS",
      "seo_description": "Discover pet-friendly living at Residences at Prairiefire, Overland Park. Spacious homes with easy access to shopping, dining, and highways.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-with-dishwashers-66223",
      "search_query": "apartments with dishwashers in 66223",
      "category": "Amenity",
      "h1_title": "Apartments with Dishwashers in 66223",
      "h2_subtitle": "Convenience meets style in apartments with dishwashers in Overland Park's 66223. Discover a new standard at Residences at Prairiefire.",
      "page_copy": "Step into a world of convenience at Residences at Prairiefire Apartment Homes, where our thoughtfully designed apartments in the 66223 area come equipped with dishwashers, making daily chores a breeze. Choose from a variety of spacious one-, two-, and three-bedroom layouts, each crafted to elevate your lifestyle.\n\nOur community places you in the heart of Overland Park, moments away from the lively Prairiefire scene, offering myriad dining and shopping opportunities. Enjoy quality features like crown molding, controlled entry, and premium finishes, with select units providing pool views or private balconies. With seamless highway connections, you'll appreciate easy commutes and adventures around Johnson County. Experience modern apartment living with the added convenience of in-home dishwashers.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Dishwashers in 66223",
      "seo_description": "Live in convenience with dishwashers at Residences at Prairiefire, Overland Park. Spacious homes in vibrant 66223 area with nearby amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-overland-park-ks",
      "search_query": "one bedroom apartments overland park ks",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Overland Park, KS",
      "h2_subtitle": "Explore our one bedroom apartments in Overland Park, KS, at Residences at Prairiefire. Perfect blend of style and convenience.",
      "page_copy": "Discover the ideal living space with our one bedroom apartments at Residences at Prairiefire Apartment Homes, situated in the thriving city of Overland Park, KS. Each unit is thoughtfully designed to provide maximum comfort and style, featuring contemporary finishes and modern amenities to suit your lifestyle.\n\nLocated near the vibrant Prairiefire area, our community offers easy access to shopping, dining, and entertainment options, making it a hub for socializing and convenience. Experience luxury amenities such as controlled access entry and the option for breathtaking pool views or a private balcony, perfect for unwinding after a busy day. With quick access to major highways, commuting and exploring Johnson County is seamless. Embrace modern living in our one bedroom apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Overland Park, KS",
      "seo_description": "Find stylish one bedroom apartments at Residences at Prairiefire in Overland Park, KS. Enjoy convenient access to local amenities and highways.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-prairiefire-kansas",
      "search_query": "two bedroom apartments prairiefire kansas",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Prairiefire, Kansas",
      "h2_subtitle": "Experience spaciousness with our two bedroom apartments in Prairiefire, Kansas. Perfect for contemporary living.",
      "page_copy": "Residences at Prairiefire Apartment Homes feature luxurious two bedroom apartments nestled in the heart of Prairiefire, Kansas. Offering expansive layouts with finely crafted details, these homes provide an ideal setting for those seeking modern living blended with convenience.\n\nOur community enhances your living experience with proximity to dining, shopping, and entertainment options in the vibrant Prairiefire neighborhood. Enjoy elevated living with features like crown molding and controlled access, along with the option of pool views or having a private balcony. Being strategically located in Overland Park, KS, with swift highway access, you'll find it easy to connect with the broader Johnson County region. Discover the perfect two bedroom apartment tailored to your lifestyle today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Prairiefire, Kansas",
      "seo_description": "Explore spacious two bedroom apartments at Residences at Prairiefire, Kansas. Enjoy modern amenities and easy access to local attractions.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-johnson-county",
      "search_query": "three bedroom apartments johnson county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Johnson County",
      "h2_subtitle": "Find spacious three bedroom apartments in Johnson County at Residences at Prairiefire, blending comfort with style.",
      "page_copy": "Residences at Prairiefire Apartment Homes provide the perfect sanctuary with our expansive three bedroom apartments located in Johnson County. Designed for families and those who love to entertain, these apartments offer ample space alongside elegant details like crown molding.\n\nSituated in the heart of Overland Park, KS, our community promises a dynamic lifestyle with immediate access to the vibrant Prairiefire district. Dive into the local culture with nearby dining and entertainment, or wind down at home with premium features including controlled access, and select units overlooking the pool or featuring private balconies. The strategic location offers easy highway access, making commuting effortless within the county and beyond. Experience elevated living in our three bedroom homes today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Johnson County",
      "seo_description": "Discover spacious three bedroom apartments at Residences at Prairiefire in Johnson County for comfortable modern living with easy access to amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-near-overland-trail-elementary-school-ks",
      "search_query": "apartments near Overland Trail Elementary School KS",
      "category": "School",
      "h1_title": "Apartments Near Overland Trail Elementary, KS",
      "h2_subtitle": "Residences at Prairiefire offers convenient living in apartments near Overland Trail Elementary School, KS, perfect for families.",
      "page_copy": "Situated conveniently in Overland Park, KS, Residences at Prairiefire Apartment Homes provide the perfect living environment for families, with proximity to Overland Trail Elementary School. Offering one, two, and three-bedroom apartments, our community is designed to cater to diverse lifestyle needs with modern finishes and resort-style amenities.\n\nBeing near educational excellence at Overland Trail Elementary School, families benefit from both quality schooling and a vibrant community setting. Our location grants easy access to the bustling Prairiefire neighborhood, where a variety of dining and entertainment choices await. Enjoy features like controlled access, balconies with pool views, and quick access to major highways for seamless commuting. Experience family-friendly living in elegance and style today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Trail Elementary School, KS",
      "seo_description": "Find family-friendly apartments near Overland Trail Elementary School at Residences at Prairiefire, Overland Park, KS. Enjoy modern amenities and convenient access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-close-to-overland-trail-middle-school-overland-park",
      "search_query": "apartments close to Overland Trail Middle School Overland Park",
      "category": "School",
      "h1_title": "Apartments Close to Overland Trail Middle School",
      "h2_subtitle": "Discover elegant living at Residences at Prairiefire, offering apartments close to Overland Trail Middle School in Overland Park.",
      "page_copy": "Residences at Prairiefire Apartment Homes present an inviting option for families seeking apartments close to Overland Trail Middle School in Overland Park. Our spacious one, two, and three-bedroom options cater to modern family life, featuring stylish interiors and resort-like amenities.\n\nLocated in the thriving Prairiefire community, you’ll enjoy easy access to excellent educational facilities like Overland Trail Middle School, alongside local dining and entertainment. With amenities such as controlled access, stunning pool views, and private balconies, you’ll find both comfort and convenience. Our location guarantees quick connections via nearby highways, allowing effortless navigation throughout Overland Park and Johnson County. Embrace community-focused living with a touch of luxury.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Overland Trail Middle School",
      "seo_description": "Explore comfortable apartments near Overland Trail Middle School at Residences at Prairiefire, Overland Park. Enjoy nearby amenities and modern living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "blue-valley-north-high-school-nearby-apartments-johnson-county",
      "search_query": "Blue Valley North High School nearby apartments Johnson County",
      "category": "School",
      "h1_title": "Apartments Near Blue Valley North High School",
      "h2_subtitle": "Explore Residences at Prairiefire in Johnson County, offering apartments near Blue Valley North High School for convenient family living.",
      "page_copy": "Residences at Prairiefire Apartment Homes offer ideal living options in Johnson County for those seeking proximity to Blue Valley North High School. Our community features spacious one, two, and three-bedroom apartments designed with modern comforts and upscale finishes.\n\nLocated in Overland Park, KS, our apartment homes provide easy access to Blue Valley North High School, promoting educational opportunities while living in a thriving community. Enjoy amenities such as controlled access, scenic pool views, and private balconies, all designed to elevate everyday living. The close proximity to Prairiefire’s shops and dining ensures a lively atmosphere, while nearby highways facilitate stress-free commuting throughout the county and into the greater Kansas City area. Experience the perfect blend of comfort and convenience today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Blue Valley North High School",
      "seo_description": "Find apartments near Blue Valley North High School at Residences at Prairiefire, Johnson County. Enjoy modern amenities and convenient educational access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "valley-park-elementary-school-apartments-66223",
      "search_query": "Valley Park Elementary School apartments 66223",
      "category": "School",
      "h1_title": "Apartments Near Valley Park Elementary School",
      "h2_subtitle": "Find your new home at Residences at Prairiefire, offering spacious apartments near Valley Park Elementary School in the 66223 area.",
      "page_copy": "For families seeking proximity to Valley Park Elementary School in the 66223 area, Residences at Prairiefire Apartment Homes provide the ideal solution. Offering spacious one, two, and three-bedroom apartments, residents enjoy elevated finishes and resort-style amenities.\n\nNestled in Overland Park, KS, our community is designed to offer both family-friendly and upscale living. Enveloped by the dynamic Prairiefire neighborhood, there’s a wealth of shopping and dining options right at your doorstep. Plus, with controlled access, balconies overlooking the pool, and easy highway access, you can enjoy both security and convenience. Discover community-focused living minutes from Valley Park Elementary School, making us the perfect choice for your family’s educational and lifestyle needs.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Valley Park Elementary School",
      "seo_description": "Discover apartments near Valley Park Elementary School at Residences at Prairiefire, located in the 66223 area. Enjoy amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "prairie-star-elementary-school-apartment-homes-overland-park-ks",
      "search_query": "Prairie Star Elementary School apartment homes Overland Park KS",
      "category": "School",
      "h1_title": "Apartment Homes Near Prairie Star Elementary",
      "h2_subtitle": "Residences at Prairiefire in Overland Park, KS offers apartment homes near Prairie Star Elementary School with premium amenities and design.",
      "page_copy": "Residences at Prairiefire Apartment Homes provides a family-friendly community within close distance to Prairie Star Elementary School in Overland Park, KS. Our selection of one, two, and three-bedroom apartments is tailored for modern living with high-end finishes and plentiful features.\n\nLocated in the vibrant Prairiefire area, residents enjoy easy access to educational institutions like Prairie Star Elementary School. Our community offers an array of amenities including controlled access, luxurious pool views, and private balconies. With quick access to local dining, shopping, and the highway, you'll appreciate the seamless blend of convenience and upscale living. Choose Residences at Prairiefire for a home that supports both educational success and a rich lifestyle experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Prairie Star Elementary",
      "seo_description": "Explore apartment homes near Prairie Star Elementary School at Residences at Prairiefire, Overland Park, KS. Enjoy family-focused amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "st-michael-the-archangel-catholic-school-nearby-apartment-living",
      "search_query": "St. Michael the Archangel Catholic School nearby apartment living",
      "category": "School",
      "h1_title": "Apartments Near St. Michael the Archangel School",
      "h2_subtitle": "Discover nearby apartment living at Residences at Prairiefire, conveniently located close to St. Michael the Archangel Catholic School.",
      "page_copy": "Residences at Prairiefire Apartment Homes offer a superb living experience for families seeking proximity to St. Michael the Archangel Catholic School. Our community features spacious one, two, and three-bedroom apartments that cater to modern lifestyles.\n\nLocated in Overland Park, KS, Residences at Prairiefire blends comfort with convenience. Enjoy controlled access, scenic views, and private balconies, making it ideal for families prioritizing both safety and leisure. The thriving neighborhood offers quick access to school, dining, shopping, and highways, ensuring an enriched lifestyle just steps away. Choose our community for both premium amenities and educational opportunities near St. Michael the Archangel Catholic School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near St. Michael the Archangel School",
      "seo_description": "Find apartment living near St. Michael the Archangel Catholic School at Residences at Prairiefire, offering modern amenities and a convenient Overland Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-near-hyman-brand-hebrew-academy-prairie-village",
      "search_query": "apartments near Hyman Brand Hebrew Academy Prairie Village",
      "category": "School",
      "h1_title": "Apartments Near Hyman Brand Hebrew Academy",
      "h2_subtitle": "Explore Residences at Prairiefire, offering apartments conveniently located near Hyman Brand Hebrew Academy in Prairie Village.",
      "page_copy": "Residences at Prairiefire Apartment Homes is an exceptional choice for families seeking apartments near Hyman Brand Hebrew Academy in Prairie Village. Our community offers a range of spacious one, two, and three-bedroom options, all equipped with high-end finishes and thoughtful amenities.\n\nSituated in Overland Park, KS, just a short drive from Prairie Village, our community blends convenience and luxury. With controlled access, pool views, and balconies, Residences at Prairiefire is designed to enhance your living experience. Close proximity to dining, shopping, and major highways provides the connectivity you need for a dynamic lifestyle. Choose us for a harmonious blend of educational proximity and upscale apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Hyman Brand Hebrew Academy",
      "seo_description": "Discover upscale apartment living near Hyman Brand Hebrew Academy at Residences at Prairiefire, with modern amenities and a prime location near Prairie Village.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "residences-near-university-of-kansas-edwards-campus",
      "search_query": "residences near University of Kansas Edwards Campus",
      "category": "School",
      "h1_title": "Residences Near University of Kansas Edwards",
      "h2_subtitle": "Residences at Prairiefire offers an ideal location near the University of Kansas Edwards Campus, combining comfort with convenience.",
      "page_copy": "Residences at Prairiefire Apartment Homes provide an excellent living environment just moments away from the University of Kansas Edwards Campus. Our community features a selection of elegantly designed one, two, and three-bedroom apartments that cater to students and professionals alike.\n\nLocated in the heart of Overland Park, KS, our residences offer easy access to education and local amenities. Enjoy features such as controlled access, balcony views, and modern community amenities that make living both convenient and enjoyable. Experience seamless accessibility to the University while enjoying a spectrum of dining, shopping, and entertainment options nearby. Choose Residences at Prairiefire for premium living near the University of Kansas Edwards Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near University of Kansas Edwards",
      "seo_description": "Find modern apartment living near the University of Kansas Edwards Campus at Residences at Prairiefire, offering comfort and a convenient Overland Park location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "johnson-county-community-college-apartments-in-prairiefire",
      "search_query": "Johnson County Community College apartments in Prairiefire",
      "category": "School",
      "h1_title": "Apartments Near Johnson County Community College",
      "h2_subtitle": "Residences at Prairiefire offers convenient apartment living close to Johnson County Community College’s vibrant educational environment.",
      "page_copy": "At Residences at Prairiefire Apartment Homes, enjoy the perfect mix of comfort and convenience, ideal for those seeking apartments near Johnson County Community College. Our sophisticated one, two, and three-bedroom units provide ample space and modern finishes that suit every lifestyle.\n\nNestled in the vibrant Prairiefire neighborhood in Overland Park, KS, the community is a stone’s throw from Johnson County Community College. With amenities like controlled access, stylish crown molding, and alluring pool views, your living experience here is as comfortable as it is secure. Proximity to shopping, dining, and entertainment ensures you have everything you need within reach while engaging in your educational pursuits. Choose our community for elegant apartment living near Johnson County Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson County Community College",
      "seo_description": "Residences at Prairiefire offers modern apartments in Prairiefire, convenient for students of Johnson County Community College.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "nearby-apartments-to-saint-thomas-aquinas-high-school",
      "search_query": "nearby apartments to Saint Thomas Aquinas High School Overland Park",
      "category": "School",
      "h1_title": "Nearby Apartments to Saint Thomas Aquinas",
      "h2_subtitle": "Discover Residences at Prairiefire, the ideal choice for luxury living near Saint Thomas Aquinas High School in Overland Park.",
      "page_copy": "Residences at Prairiefire Apartment Homes offer the perfect setting for families and individuals seeking nearby apartments to Saint Thomas Aquinas High School in Overland Park. Our community features spacious one, two, and three-bedroom apartments with premium finishes and essential amenities that reflect both style and functionality.\n\nLocated conveniently in Overland Park, KS, our residents enjoy immediate access to Saint Thomas Aquinas High School, making daily commutes simple and stress-free. With highlights such as controlled access, beautiful pool views, and private balconies, each unit is crafted for comfort and modern living. Moreover, residents are positioned near a host of dining, shopping, and entertainment attractions, reinforcing the blend of education and lifestyle conveniences by living at Residences at Prairiefire.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Nearby Apartments to Saint Thomas Aquinas",
      "seo_description": "Choose Residences at Prairiefire for stylish living near Saint Thomas Aquinas High School, with modern amenities in Overland Park.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-near-childrens-mercy-kansas-johnson-county",
      "search_query": "apartments near children's mercy kansas in johnson county",
      "category": "Hospital",
      "h1_title": "Apartments Near Children's Mercy in Kansas",
      "h2_subtitle": "Residences at Prairiefire offer exceptional living near Children's Mercy Kansas in Johnson County, making life convenient and stylish.",
      "page_copy": "Residences at Prairiefire Apartment Homes present a perfect living solution for those seeking apartments near Children's Mercy Kansas in Johnson County. Our modern one, two, and three-bedroom homes are thoughtfully designed, offering luxury amenities and spacious living areas ideal for professionals and families alike.\n\nSituated in scenic Overland Park, KS, our location guarantees effortless access to Children's Mercy Kansas, streamlining daily commutes. Enjoy features like secure controlled access, a balcony with picturesque views, and community conveniences that enhance your lifestyle. Positioned in a vibrant area brimming with shopping, dining, and entertainment, the Residences at Prairiefire combine the comfort of home with the charm of Johnson County living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Children's Mercy in Kansas",
      "seo_description": "Residences at Prairiefire offers premium apartments near Children's Mercy Kansas, combining comfort with easy access in Johnson County.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "residences-near-overland-park-regional-medical-center",
      "search_query": "residences near overland park regional medical center zip code 66223",
      "category": "Hospital",
      "h1_title": "Residences Near Overland Park Regional Medical",
      "h2_subtitle": "Explore Residences at Prairiefire, offering upscale living conveniently near Overland Park Regional Medical Center in zip code 66223.",
      "page_copy": "Welcome to Residences at Prairiefire Apartment Homes, where modern living meets excellent locale for those searching for residences near Overland Park Regional Medical Center in zip code 66223. Our community features expansive one, two, and three-bedroom apartments with high-end finishes designed to provide both comfort and style.\n\nSituated in the energetic heart of Overland Park, KS, our community grants close proximity to Overland Park Regional Medical Center, ensuring smooth and simple access for healthcare professionals and visitors. Enjoy the tranquility of our controlled access areas, the elegance of crown molding, and take in the serene pool views. With a rich array of shopping, dining, and entertainment options just moments away, Residences at Prairiefire delivers the perfect blend of leisure and practicality.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near Overland Park Regional Medical",
      "seo_description": "Residences at Prairiefire offers comfortable living near Overland Park Regional Medical Center in zip code 66223 with modern amenities and easy accessibility.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-near-overland-park-arboretum-botanical-gardens",
      "search_query": "apartments near Overland Park Arboretum & Botanical Gardens",
      "category": "Park",
      "h1_title": "Apartments Near Overland Park Arboretum",
      "h2_subtitle": "Discover Residences at Prairiefire, providing luxury living near Overland Park Arboretum & Botanical Gardens.",
      "page_copy": "If you're searching for apartments that offer both luxury and proximity to nature, look no further than Residences at Prairiefire Apartment Homes. Located near the Overland Park Arboretum & Botanical Gardens, our spacious one, two, and three-bedroom homes are designed with elegant finishes and practical amenities.\n\nIn Overland Park, KS, our apartment community combines scenic views with modern living. Enjoy quick access to the beautiful Overland Park Arboretum, perfect for those who appreciate nature's tranquillity. Residences at Prairiefire boast features like controlled access, stunning pool views, and balconies ideal for relaxation. Beyond natural attractions, indulge in the vibrant shopping, dining, and entertainment spots that make living here both convenient and delightful.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Overland Park Arboretum",
      "seo_description": "Residences at Prairiefire offer luxury apartments near Overland Park Arboretum & Botanical Gardens, blending nature and modern living seamlessly.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-close-to-quivira-park-overland-park",
      "search_query": "apartments close to Quivira Park Overland Park",
      "category": "Park",
      "h1_title": "Apartments Close to Quivira Park in Overland Park",
      "h2_subtitle": "Residences at Prairiefire offers exquisite living close to Quivira Park, enhancing your Overland Park experience with modern amenities.",
      "page_copy": "Residences at Prairiefire Apartment Homes provide an excellent option for those searching for apartments close to Quivira Park in Overland Park. Our community features sophisticated one, two, and three-bedroom apartments that seamlessly combine comfort with style, just a short distance from the lush landscapes of Quivira Park.\n\nSet in the thriving city of Overland Park, KS, our residences are ideal for enjoying both outdoor recreation and urban conveniences. Immerse yourself in our resort-style amenities, including balconies with scenic views and controlled access entries. Whether you're spending a day at Quivira Park or exploring local dining and entertainment, Residences at Prairiefire ensure a blend of leisure and luxury right at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Quivira Park in Overland Park",
      "seo_description": "Explore Residences at Prairiefire, offering stylish apartments close to Quivira Park in Overland Park, featuring modern amenities and breathtaking views.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "residences-by-thomas-stoll-memorial-park",
      "search_query": "residences by Thomas S. Stoll Memorial Park KS",
      "category": "Park",
      "h1_title": "Residences by Thomas S. Stoll Memorial Park",
      "h2_subtitle": "Discover luxury living at Residences at Prairiefire, located near Thomas S. Stoll Memorial Park, KS. Enjoy nature paired with comfort.",
      "page_copy": "Welcome to Residences at Prairiefire Apartment Homes, where you can enjoy premium living by the serene Thomas S. Stoll Memorial Park, KS. Our community offers expansive one, two, and three-bedroom apartments with high-end finishes, creating a perfect retreat just moments away from the park's lush greenery.\n\nSituated in Overland Park, our residences deliver easy access to both natural beauty and city attractions. Retreat within our controlled access community or enjoy pool views from your private balcony. With proximity to Thomas S. Stoll Memorial Park, you can experience the tranquility of nature alongside the vibrance of local dining and shopping. Residences at Prairiefire provide the ideal balance between luxury and connectivity in Overland Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences by Thomas S. Stoll Memorial Park",
      "seo_description": "Residences at Prairiefire offer spacious apartments near Thomas S. Stoll Memorial Park, KS, combining community comfort with park-side living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartment-homes-near-corporate-woods-founders-park",
      "search_query": "apartment homes near Corporate Woods Founders Park",
      "category": "Park",
      "h1_title": "Apartment Homes Near Corporate Woods Founders Park",
      "h2_subtitle": "Live luxuriously at Residences at Prairiefire, located near Corporate Woods Founders Park, offering the perfect blend of comfort and convenience.",
      "page_copy": "Experience contemporary living at Residences at Prairiefire Apartment Homes, situated conveniently near Corporate Woods Founders Park. Our community features a selection of one, two, and three-bedroom apartment homes that exemplify modern design and quality craftsmanship, just a stone's throw from the lush Corporate Woods Founders Park.\n\nLocated in the vibrant city of Overland Park, KS, our apartments offer more than just luxurious interiors; they provide easy access to the stunning landscapes and walking trails of Corporate Woods Founders Park. Residents enjoy amenities like controlled access, private balconies, and captivating pool views. Experience the best of both worlds with a location that is perfect for business professionals and nature enthusiasts alike, all while being close to shopping and dining options.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Corporate Woods Founders Park",
      "seo_description": "Residences at Prairiefire offers premier apartment homes near Corporate Woods Founders Park, combining luxury interiors with serene park access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "prairiefire-apartments-by-regency-lake-park",
      "search_query": "Prairiefire apartments by Regency Lake Park",
      "category": "Park",
      "h1_title": "Prairiefire Apartments by Regency Lake Park",
      "h2_subtitle": "Discover Residences at Prairiefire, located near Regency Lake Park, where luxury meets scenic tranquility in Overland Park.",
      "page_copy": "Nestled close to the picturesque Regency Lake Park, Residences at Prairiefire Apartment Homes offer a premier living experience in Overland Park, KS. Our elegant one, two, and three-bedroom apartments deliver top-tier finishes and resort-style amenities, perfect for those seeking comfort near Regency Lake Park.\n\nEnjoy the convenience of having a serene park setting just a short stroll away, while residing in a community equipped with controlled access and lovely pool views. Embrace the balance of peaceful parkside walks and the excitement of nearby shopping and dining at Prairiefire apartments. Whether relaxing on your private balcony or exploring nature, our location by Regency Lake Park is an exceptional place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairiefire Apartments by Regency Lake Park",
      "seo_description": "Explore Residences at Prairiefire, near Regency Lake Park, offering luxurious apartment living with beautiful views and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-in-johnson-county-near-amesbury-lake-park",
      "search_query": "apartments in Johnson County near Amesbury Lake Park",
      "category": "Park",
      "h1_title": "Apartments in Johnson County Near Amesbury Lake Park",
      "h2_subtitle": "Find your dream home at Residences at Prairiefire, perfectly situated near Amesbury Lake Park in Johnson County, KS.",
      "page_copy": "Welcome to Residences at Prairiefire, luxurious apartments nestled in the heart of Johnson County, KS, near the beautiful Amesbury Lake Park. Offering a selection of spacious one, two, and three-bedroom homes, our community is designed with high-end finishes and resort-style amenities that provide a serene living experience close to natural beauty.\n\nLocated in vibrant Overland Park, our residents enjoy easy access to the tranquility of Amesbury Lake Park as well as the area's dynamic shopping and dining scenes. The community boasts controlled access and delightful views that create an inviting ambiance. Experience the perfect combination of natural exploration and urban convenience by choosing our apartment homes near Amesbury Lake Park as your residence.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Johnson County Near Amesbury Lake Park",
      "seo_description": "Discover luxurious living at Residences at Prairiefire, near Amesbury Lake Park in Johnson County, KS, offering high-end amenities and scenic surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "overland-park-rentals-close-to-olathe-two-trails-park",
      "search_query": "Overland Park rentals close to Olathe Two Trails Park",
      "category": "Park",
      "h1_title": "Overland Park Rentals Near Olathe Two Trails Park",
      "h2_subtitle": "Discover premium rentals at Residences at Prairiefire, perfectly situated close to Olathe Two Trails Park in Overland Park.",
      "page_copy": "Residences at Prairiefire Apartment Homes offer exceptional rental options in Overland Park, KS, conveniently close to the scenic Olathe Two Trails Park. Whether you're looking for a one-bedroom sanctuary or a spacious three-bedroom retreat, our homes provide polished interiors and top-tier amenities that will make you feel right at home.\n\nOur strategic location not only connects you to the vibrant energy of Overland Park's shopping and dining but also places you near the natural beauty of Olathe Two Trails Park. Enjoy tranquil walks or active recreation moments away from home, enhanced by our community's resort-style features. Experience the ultimate balance of natural beauty and urban living at our premium Overland Park rentals today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Overland Park Rentals Near Olathe Two Trails Park",
      "seo_description": "Residences at Prairiefire offer premium rental homes in Overland Park, close to Olathe Two Trails Park, with luxurious amenities and scenic access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "prairiefire-apartment-homes-near-overland-park-city-hall",
      "search_query": "Prairiefire apartment homes near Overland Park City Hall",
      "category": "Park",
      "h1_title": "Prairiefire Apartments Near Overland Park City Hall",
      "h2_subtitle": "Explore the ideal location of Residences at Prairiefire, conveniently near Overland Park City Hall.",
      "page_copy": "Residences at Prairiefire Apartment Homes offer a luxurious living experience in Overland Park, KS, just moments from Overland Park City Hall. Our community features exquisite one, two, and three-bedroom apartments, each with modern design and premium amenities that cater to your lifestyle needs.\n\nPositioned near the heart of the city, living here means you're close to key municipal locations and the vibrant city life. With convenient access to shopping, dining, and entertainment, along with serene residential amenities like pool views and controlled access, Prairiefire apartment homes provide the perfect balance of activity and relaxation. Discover all that our conveniently located community near Overland Park City Hall has to offer.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Prairiefire Apartments Near Overland Park City Hall",
      "seo_description": "Discover luxury living at Residences at Prairiefire, just moments from Overland Park City Hall, combining city access with stylish amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162465",
      "property_id": "6767906449167620",
      "source": "generator",
      "page_item_url": "apartments-near-kansas-city-international-airport-overland-park",
      "search_query": "apartments near kansas city international airport overland park",
      "category": "Transit",
      "h1_title": "Apartments Near Kansas City Intl Airport, Overland Park",
      "h2_subtitle": "Residences at Prairiefire offers convenient living in Overland Park, with easy access to Kansas City International Airport.",
      "page_copy": "Residences at Prairiefire Apartment Homes provide the perfect blend of luxury and convenience in Overland Park, KS, with proximity to Kansas City International Airport. Our community features a range of spacious one, two, and three-bedroom apartments designed with premium finishes and resort-style amenities, ensuring a comfortable home environment.\n\nOur strategic location ensures you're never far from travel convenience, making trips to and from the airport seamless. Moreover, within minutes, you can enjoy Overland Park's vibrant shopping, dining, and entertainment venues. Experience the advantage of living at a community that offers access to both the bustling energy of urban life and the peace of a beautifully manicured residence.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1920/property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of apartment buildings, pool, and golf course.",
        "public_id": "019fc993-3150-710b-804e-a0e74d542531",
        "storage_key": "property/6767906449167620/019fc993-3150-710b-804e-a0e74d542531.webp",
        "width": 2048,
        "height": 1365
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Kansas City Intl Airport, Overland Park",
      "seo_description": "Residences at Prairiefire, luxury apartments in Overland Park, offer easy access to Kansas City International Airport along with premium amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "bobbi@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12701964768"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PSSJ7F3V"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Batch 6"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Vantage"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_rentcafe_chatbot",
      "type": "STRING",
      "value": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/f8adb510-32b3-4bfa-8d3d-994c076c4da4/app.js?nocache=1&gaTracking=G-ZZZXPJZV42&buttonbgcolor=ff9000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "913-380-0510"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjhIQTNXcUtNNmt1QUwxZWV2NU5wZ2c9PSIsInZhbHVlIjoiYzlReXFtQ2pQbkNxMi95VlhOMWhJdz09IiwibWFjIjoiNWQyMGIwNzE2NWNiMWM0ZTViN2FkZmFiZTZjMWU3ODQ1NmM5OWI2ODlmYTEyMTIxYjI4MThmYTIxYzAzNjllMyJ9"
    }
  ],
  "custom_csm": "bobbi@repli360.com",
  "custom_repli_id": "12701964768",
  "custom_google_gtm_id": "GTM-PSSJ7F3V",
  "custom_rollout_phase": "Batch 6",
  "custom_vibesites_theme": "Vantage",
  "custom_ads_subscription": "essential",
  "custom_rentcafe_chatbot": "<script type=\"text/javascript\" src=\"//webchat.omni.cafe/webchatjs/f8adb510-32b3-4bfa-8d3d-994c076c4da4/app.js?nocache=1&gaTracking=G-ZZZXPJZV42&buttonbgcolor=ff9000&buttontextcolor=ffffff&chatheader=0&embed=false\"></script>",
  "custom_seo_subscription": "essential",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_ppc_tracking_phone_number": "913-380-0510",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjhIQTNXcUtNNmt1QUwxZWV2NU5wZ2c9PSIsInZhbHVlIjoiYzlReXFtQ2pQbkNxMi95VlhOMWhJdz09IiwibWFjIjoiNWQyMGIwNzE2NWNiMWM0ZTViN2FkZmFiZTZjMWU3ODQ1NmM5OWI2ODlmYTEyMTIxYjI4MThmYTIxYzAzNjllMyJ9",
  "custom_audioeye_site_id": "4fcefb03-e069-475f-901d-04c106896fd8",
  "custom_audioeye_site_hash": "058228997de01713a4192828364a0b64"
};

export const generatedAt = '2026-11-03T22:58:02.563Z';
